// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:16:03.530Z
// Property: Ridgewood (ID: 6737460151191764)
// Collections: 28 amenities, 12 floorplans (live), 45 photos, 88 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191764",
  "property_external_id": "4857250",
  "property_zillow_url": "https://www.zillow.com/apartments/savannah-ga/ridgewood/5Xt54Q/",
  "property_apartments_url": "https://www.apartments.com/ridgewood-savannah-ga/gb28c9z",
  "property_google_business_url": "https://www.google.com/maps/place/Ridgewood/data=!4m2!3m1!1s0x0:0x21f17fdbe3814d20?sa=X&ved=2ahUKEwiZjMrNvLySAxXQzvACHTaKOusQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321172567",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "ridgewood",
  "property_name": "Ridgewood",
  "property_website_url": "https://www.ridgewoodsavannah.com/",
  "property_domain": "https://www.ridgewoodsavannah.com/",
  "property_address": "12008 Middleground Rd",
  "property_full_address": "12008 Middleground Rd, Savannah, GA 31419",
  "property_address_1": "12008 Middleground Rd",
  "property_address_2": null,
  "property_address_city": "Savannah",
  "property_address_state": "GA",
  "property_address_zip_full": "31419-3600",
  "property_address_zip": "31419",
  "property_address_country": "US",
  "property_address_county": "Chatham County",
  "property_neighborhood_address": "Wilshire Estates",
  "property_address_latitude": "31.9853656",
  "property_address_longitude": "-81.16294839999999",
  "property_email": "ridgewood.mgr@rrliving.com",
  "property_phone": "(812) 301-6334",
  "property_call_tracking_phone": "812-203-5048",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Embrace the vibrant lifestyle at Ridgewood in Savannah, GA, where spacious one, two, and three-bedroom apartments meet exceptional amenities. Dive into relaxation at our pool, energize in the fitness center, or enjoy the sun on the sundeck. Your perfect home awaits—browse availability or schedule a tour today!",
  "property_long_description": "Welcome to Ridgewood, the premier apartment community in beautiful Savannah, GA! Discover a range of thoughtfully designed floor plans offering one, two, and three-bedroom options to suit your lifestyle needs. Our spacious apartments come equipped with modern amenities and the option for furnished units, ensuring you feel right at home from day one.\n\nAt Ridgewood, we understand that great living goes hand in hand with exceptional amenities. Dive into relaxation at our sparkling pool, work up a sweat in our fully-equipped fitness center, or unwind in our inviting clubhouse. Grab a game with friends in the game room or soak up the sun on our sundeck overlooking the lush courtyard. Whether you're hosting a barbecue at our grill area or enjoying a leisurely stroll in our on-site dog park, Ridgewood offers a vibrant community atmosphere.\n\nFor those who work from home or need a quiet space for studying, our business center is the perfect solution. With 24-hour access, you can balance work and leisure at your convenience. Plus, our on-site maintenance and property manager ensure that all your needs are promptly met.\n\nLocated conveniently in Savannah, Ridgewood combines comfort, style, and community living—all just a stone's throw from local attractions. Don't wait any longer to find your new home! Browse our availability or schedule a tour today to experience all that Ridgewood has to offer. Your ideal apartment is only a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-dbe7-77cd-8ee8-afb2e7acb4e2.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and trees under a clear blue sky.",
    "public_id": "019fb34e-dbe7-77cd-8ee8-afb2e7acb4e2",
    "storage_key": "property/6737460151191764/019fb34e-dbe7-77cd-8ee8-afb2e7acb4e2.webp",
    "width": 2000,
    "height": 1333
  },
  "property_featured_video": "https://media.multihub.io/property/6737460151191764/019fd363-aadb-70de-95cd-a0ede4fd3a03.mp4",
  "property_featured_video_media": null,
  "property_total_units": "144",
  "property_year_built": "1977",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.36111111111111",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "15",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs are welcome with no breed restrictions. Maximum of 2 pets per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://ridgewoodsavannah.loftliving.com/login",
  "property_apply_now_url": "https://8747934.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-9d91-76dc-87c1-6daf2734acb5.webp",
  "property_primary_logo_media": {
    "alt_text": "Ridgewood Apartment Homes logo",
    "public_id": "019e1e3a-9d91-76dc-87c1-6daf2734acb5",
    "storage_key": "property/6737460151191764/019e1e3a-9d91-76dc-87c1-6daf2734acb5.webp",
    "width": 628,
    "height": 397
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-dc9a-775e-9df2-89e4cc1f8b6f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Ridgewood Apartment Homes logo",
    "public_id": "019e8492-dc9a-775e-9df2-89e4cc1f8b6f",
    "storage_key": "property/6737460151191764/019e8492-dc9a-775e-9df2-89e4cc1f8b6f.webp",
    "width": 743,
    "height": 420
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8493-abaa-772d-aafc-d7325f0a379c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8493-abaa-772d-aafc-d7325f0a379c",
    "storage_key": "property/6737460151191764/019e8493-abaa-772d-aafc-d7325f0a379c.webp",
    "width": 628,
    "height": 397
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8493-a075-759e-838f-acfe1d142247.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8493-a075-759e-838f-acfe1d142247",
    "storage_key": "property/6737460151191764/019e8493-a075-759e-838f-acfe1d142247.webp",
    "width": 628,
    "height": 397
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#283618",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#83918f",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "820 - 1220",
  "property_sqft_min": "820",
  "property_sqft_max": "1220",
  "property_price_range": "1970",
  "property_price_min": null,
  "property_price_max": "1970",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/Kole.RidgewoodApt/",
  "property_instagram_url": "https://www.instagram.com/ridgewood_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJwTzbgcx0-4gRIE2B49t_8SE",
  "property_youtube_url": "https://www.youtube.com/watch?t=380&v=0NqJofyOkJY",
  "property_yelp_url": "https://www.yelp.com/biz/ridgewood-apartments-savannah",
  "property_tiktok_url": "https://www.tiktok.com/@ridgewood.apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ridgewood",
  "property_home_romance_title": "Embrace Endless Comfort and Connection at Your New Home",
  "property_home_amenities_blurb": "<p>Searching for conventional apartment home living in Savannah, Georgia? Well, look no further than Ridgewood apartments! We offer <a href=\"/floor-plans/\">one, two, and three bedroom apartments</a> for rent that are designed with your comfort in mind. With amazing amenities such as a dishwasher, sleek black appliances, and a divided sink. You won’t have to worry about space as all of our apartments feature a separate dining area and utility room. Along with 9-foot ceilings and ceiling fans, you can feel chill and relax in your new home.</p>",
  "property_home_floorplans_blurb": "<p>Searching for conventional apartment home living in Savannah, Georgia? Well, look no further than Ridgewood <a href=\"/floor-plans/\">apartments</a>! We are nestled just outside of the heart of the city and close to Berkshire Woods. You can experience the ease of city living as well as the ruggedness of the outdoors. With plenty of incredible local restaurants, shopping, and recreation, you will fall in love with our serene pet-friendly community.</p>",
  "property_home_gallery_blurb": "At Ridgewood in charming Savannah, GA, every detail is designed for comfort and convenience. Choose from thoughtfully crafted one, two, or three-bedroom floor plans. Enjoy exclusive amenities like a refreshing pool, vibrant clubhouse, and serene Zen garden. Picture yourself living here, where lifestyle meets leisure every day.",
  "property_home_neighborhood_blurb": "Nestled in vibrant Savannah, GA, Ridgewood offers diverse floor plans to fit your lifestyle—choose from cozy one-bedroom retreats to spacious three-bedroom homes. Immerse yourself in the rich local culture by exploring nearby favorites and attractions that make our community truly exceptional. Uncover the charm of Ridgewood!",
  "property_home_reviews_blurb": "Nestled in a tranquil setting of Savannah, Ridgewood Apartments boasts spacious layouts and ample closet space that residents rave about. One resident shares, “The staff is absolutely amazing,” while another highlights the peaceful community spirit. Experience comfort and convenience, all just minutes from Armstrong University and Savannah Mall.",
  "property_neighborhood_blurb": "<p>Searching for conventional apartment home living in Savannah, Georgia? Well, look no further than Ridgewood <a href=\"/floor-plans/\">apartments</a>! We are nestled just outside of the heart of the city and close to Berkshire Woods. You can experience the ease of city living as well as the ruggedness of the outdoors. With plenty of incredible local restaurants, shopping, and recreation, you will fall in love with our serene pet-friendly community.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Challenge the family to a game of table tennis, foosball or corn hole, and then sit and cool down at our outdoor grilling station with a pergola. If that’s not your style, soak up the sun by our shimmering swimming pool and sundeck. Your pet can also enjoy Ridgewood at our bark park with agility equipment. See for yourself how marvelous our <a href=\"/neighborhood/\">apartment community</a> is and, call our amazing Savannah, GA management team to schedule a tour today!</p>",
  "property_applynow_blurb": "At Ridgewood in beautiful Savannah, GA, choose from spacious one, two, or three-bedroom layouts that blend comfort with convenience. Enjoy a vibrant community featuring a sparkling pool, fitness center, gameroom, and dog park. Ready for your perfect home? Lease online today and embrace a lifestyle designed for you!",
  "property_contactus_blurb": "At Ridgewood in Savannah, GA, your perfect home awaits. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to every lifestyle. Whether you're seeking cozy comfort or spacious living, we have a layout just for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Ridgewood in Savannah, GA, our thoughtfully designed one, two, and three-bedroom apartments cater to your unique lifestyle. Curious about amenities, leasing, or community events? Uncover valuable insights on our Frequently Asked Questions page, where answers await to help you navigate your new home with ease and confidence.",
  "property_floorplans_blurb": "<p>Your search to find available apartments in Savannah, GA has led you to the right place. Just by clicking on a few buttons you will have a list of our current availabilities at your fingertips. From our spacious interiors to our exterior <a href=\"/amenities/\">amenities</a> there will be something that will make you want to call us home.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our community and apartments.</p>",
  "property_interactivemap_blurb": "Welcome to Ridgewood in Savannah, GA, where modern living meets comfort. Choose from our thoughtfully designed one, two, or three-bedroom apartments. With amenities like a sparkling pool, a fitness center, and a dog park, your lifestyle awaits. Dive into our interactive community map to find your perfect home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Ridgewood in vibrant Savannah, GA, you'll find the perfect sanctuary with floor plans ranging from cozy one-bedroom retreats to spacious three-bedroom homes. Great friends make great neighbors—refer a friend to our community today and experience the joy of living in an inviting environment together!",
  "property_residentaccess_blurb": "Welcome to Ridgewood, your serene oasis in Savannah, GA. Whether you choose a cozy one-bedroom or a spacious three-bedroom, our thoughtfully designed floor plans maximize comfort. Access your resident portal today to effortlessly pay rent, schedule maintenance, and elevate your living experience. Your home awaits!",
  "property_reviews_blurb": "At Ridgewood Apartments in Savannah, you’ll find a serene community brimming with spacious living and exceptional service. Residents rave about the \"amazing\" office staff and “quick” maintenance response. Enjoy ample closet space in a quiet neighborhood, close to Armstrong University and Savannah Mall. Join our family and experience the difference!",
  "property_created_at": "1752257092708",
  "property_scheduletour_blurb": "At Ridgewood in charming Savannah, GA, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Experience community life at its best—schedule a tour today and hear firsthand from our residents why Ridgewood is their cherished home sweet home!",
  "property_thankyou_blurb": "Thank you for reaching out to Ridgewood, your future home in the heart of Savannah, GA. With thoughtfully designed one, two, and three-bedroom floor plans, we’re excited to help you find the perfect space. Our team will be in touch soon to guide you on this exciting journey!",
  "property_virtualtours_blurb": "<p>At Ridgewood, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Ridgewood",
  "property_seo_title_home": "Ridgewood | Apartments in Savannah, GA",
  "property_seo_description_home": "Welcome to Ridgewood in the heart of Savannah, GA, where comfort meets convenience. Choose from our spacious one, two, or three-bedroom floor plans that cater to your lifestyle. Enjoy a refreshing dip in the pool, work up a sweat in our well-equipped fitness center, or unwind at our clubhouse. With unique amenities like a gameroom, dog park, and sun-kissed sundeck, every day feels like a retreat. Plus, our dedicated on-site team ensures maintenance and package services are just a click away. Your vibrant new home awaits you—find your perfect apartment today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Savannah, GA",
  "property_seo_description_floorplans": "Unlock the door to your ideal living space at Ridgewood in Savannah, GA. Whether you’re seeking a cozy one-bedroom retreat, a spacious two-bedroom haven, or a family-friendly three-bedroom layout, we have the perfect floor plan tailored just for you. Browse our available apartment homes today and envision your next chapter at Ridgewood!",
  "property_seo_title_amenities": "Amenities | Savannah, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Ridgewood in Savannah, GA! Our community offers an array of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Dive into luxury with a sparkling pool, energize in our fully-equipped fitness center, or unwind at our inviting clubhouse. Enjoy on-site conveniences like package service and dedicated maintenance, plus specialized amenities like a dog park for your furry friends. Step into comfort and community—your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Savannah, GA",
  "property_seo_description_gallery": "Immerse yourself in the vibrant lifestyle at Ridgewood, Savannah's premier apartment community. With spacious one, two, and three-bedroom floor plans, you'll find the perfect home tailored to your needs. Enjoy resort-style amenities including a sparkling pool, state-of-the-art fitness center, and a welcoming dog park for your furry friends. Picture yourself relaxing on the sun-drenched sundeck or hosting friends at the clubhouse and grill area. Dive into our photo gallery and envision the life you could have here!",
  "property_seo_title_virtualtours": "Virtual Tours | Ridgewood Apartments",
  "property_seo_description_virtualtours": "Experience the serene charm of Ridgewood in Savannah, GA, where comfort meets modern living. Delve into our diverse floor plans—choose from one, two, or three-bedroom apartments designed with your lifestyle in mind. Take a virtual tour now and envision your future home nestled in our vibrant community!",
  "property_seo_title_interactivemap": "Interactive Map | Ridgewood Apartments",
  "property_seo_description_interactivemap": "\"Welcome to Ridgewood in Savannah, GA – your gateway to a vibrant lifestyle. With thoughtfully designed one, two, and three-bedroom apartments, our community features a refreshing pool, a fully equipped fitness center, and a welcoming clubhouse. Enjoy the convenience of on-site management, package services, and 24-hour access. Unwind in our sundeck, dog park, or gameroom. Want to find your perfect place? Use our interactive community map to discover available apartments and pricing today!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Savannah, GA",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood of Ridgewood in Savannah, GA, where local favorites and hidden gems await just outside your door. From charming cafes to picturesque parks, your new home is surrounded by the best the city has to offer. See what’s around our community and let the adventure begin!",
  "property_seo_title_contact": "Contact Us | Ridgewood",
  "property_seo_description_contact": "Experience the charm of Ridgewood in Savannah, GA, where your perfect apartment awaits! Whether you’re seeking a cozy one-bedroom, a spacious two-bedroom, or a luxurious three-bedroom layout, our diverse floor plans cater to your unique lifestyle. Have questions? Reach out to our friendly leasing team today and take the first step towards your new home!",
  "property_seo_title_faqs": "FAQs | Apartments in Savannah, GA",
  "property_seo_description_faqs": "Elevate your lifestyle at Ridgewood in Savannah, GA, where comfort meets convenience. Our versatile floor plans—one, two, and three bedrooms—accommodate every need. Indulge in amenities like a sparkling pool, a state-of-the-art fitness center, and a vibrant clubhouse. Enjoy 24-hour access, on-site maintenance, and a thrilling gameroom, alongside relaxing spaces like our sundeck and dog park. Curious about life at Ridgewood? Visit our FAQs page for answers to your burning questions and uncover the community you've been searching for!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Savannah, GA",
  "property_seo_description_reviews": "\"At Ridgewood in Savannah, GA, our vibrant community thrives with spacious one, two, and three-bedroom floor plans matched with enriching amenities. From lounging by the resort-style pool to staying fit in our fully-equipped fitness center, every day feels like a getaway. Enjoy the lively clubhouse, peaceful dog park, and gameroom for fun gatherings. Ready to see if it’s the right fit? Check out what our residents have to say about life at Ridgewood!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Savannah, GA",
  "property_seo_description_applynow": "Elevate your lifestyle at Ridgewood in Savannah, GA, where modern living meets comfort and convenience. Choose from thoughtfully designed one, two, and three-bedroom floor plans, tailored to suit your needs. Enjoy resort-style amenities, including a sparkling pool, a fully-equipped fitness center, and a vibrant clubhouse. With features like a gameroom, sundeck, and a welcoming dog park, there's something for everyone. Experience hassle-free living with onsite maintenance, package service, and 24-hour access. Ready to make the move? Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Ridgewood",
  "property_seo_description_residentaccess": "\"Welcome to Ridgewood in Savannah, GA—your gateway to convenient living. Log in to your resident portal for seamless rent payments, hassle-free maintenance requests, and exclusive community updates. Elevate your apartment experience today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Ridgewood",
  "property_seo_description_referafriend": "\"At Ridgewood in Savannah, GA, great friends make the best neighbors! Share the joy of community living by referring a friend today and enjoy exclusive perks together. Connect with us and let the good times roll in your new home!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Ridgewood",
  "property_seo_description_scheduletour": "\"Step into your future at Ridgewood in Savannah, GA! Our vibrant apartment community offers timeless charm and modern amenities that invite you to create lasting memories. Schedule a tour today and see why Ridgewood is more than just a place to live—it's your next home!\"",
  "property_seo_title_privacy": "Privacy Policy | Ridgewood",
  "property_seo_description_privacy": "At Ridgewood in Savannah, GA, your privacy matters. Our policy outlines how we protect your personal information while you enjoy our vibrant community. Dive into the details of our commitment to your security—because your trust is our priority. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Ridgewood",
  "property_seo_description_accessibility": "\"At Ridgewood in Savannah, GA, we prioritize digital inclusion for all. Our Accessibility Statement outlines our commitment to creating a welcoming online experience, ensuring everyone can effortlessly navigate and connect with our vibrant apartment community. Join us in building a more accessible future!\"",
  "property_seo_title_sitemap": "Sitemap | Ridgewood",
  "property_seo_description_sitemap": "\"Navigate your way to your new home at Ridgewood in Savannah, GA! Our sitemap is your comprehensive guide to exploring our vibrant community, amenities, and floor plans. Dive in and uncover everything Ridgewood has to offer!\"",
  "property_seo_title_thankyou": "Thank You | Ridgewood",
  "property_seo_description_thankyou": "Thank you for your interest in Ridgewood, where charming Savannah living meets modern comfort. Your inquiry is on its way—one of our friendly team members will reach out soon to answer your questions and help you start your journey home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Savannah, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293557667",
  "amenities": [
    {
      "id": "custom_417b124a-2df7-4483-a389-8ea976d11e0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6608ac11-bc8a-4633-b6b9-947ad3df89c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_93331aff-38c5-4704-a9d6-7a4e38f00547",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_196b3f4b-721c-4150-a9f7-c47569396e0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Car Wash Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1812f4cf-f02d-440b-b1ff-0ba8d0714ccf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f27ef56-84c6-4e8f-8eb6-2f647c43a71b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cb671f8c-bd04-464e-a2b7-8bdc47dd4216",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d21f701f-f996-4327-8743-c6b9bd41de14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2520308-c06e-457b-8fd5-ea042d69a521",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Grilling Station with Pergola",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2534bcee-9076-4c4e-b4a2-21d620f04446",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Play Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05986b64-6e20-47eb-964a-fb8c957570b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Preferred Employer Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72413e4d-2643-4e40-ae05-4ed26c8f9458",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5181fc56-2f17-4ec6-88eb-3ab4596d22fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0f46935-529d-4b25-a678-b42305136491",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑art Wellness Studio",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f85c6bc6-8596-453e-a595-fc591b7ef18d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55e5c137-5a50-4893-af85-70d07de2b7bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Corn Hole",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bea8f16-5b8b-419d-922e-b1d0ece53895",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "9ft Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5d9706bd-1a4f-47a5-ac5e-0e0c724cd45c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6a2094a7-c32c-4d29-95dc-577d454265af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de8065b1-d258-4376-82ce-0574a33eb8d5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Divided sink",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ceb7a9c-a84d-486f-ba38-fcbda792b7a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Separate Dining Room",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2751932a-72d7-4f42-9be5-e5dc82611619",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Separate Utility Room",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ce5cdd2a-4e2f-4a99-bf9c-762f557eb3dc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Sleek Black Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af83c430-0617-45b8-8a0c-a4daf850d874",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b945d91-a798-4e56-b536-b5543f456a6c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer in Home*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f996b24e-8b24-4bbd-be06-d1bf432e905a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b0d9d5f6-f299-44aa-9b99-47e0a3a906cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Style Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_58c8810a-a879-491e-ae29-1df8e2792809",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "external_id": "false",
      "title": "Carpet in Bedrooms\"",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ff9a6c89-2305-4905-9f7f-1f13c37b1574",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-d786-73d9-9681-9021f5ea48a1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, subway tile backsplash, stainless steel sink, black refrigerator, and stove.",
        "public_id": "019fb34e-d786-73d9-9681-9021f5ea48a1",
        "storage_key": "property/6737460151191764/019fb34e-d786-73d9-9681-9021f5ea48a1.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, granite countertops, and a sleek subway tile backsplash. Equipped with essential appliances for your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, subway tile backsplash, stainless steel sink, black refrigerator, and stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f96c447-1fdf-47aa-b4ca-3ef00a88d8aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-d856-700a-83a1-f49c91be0ecb.webp",
      "image_media": {
        "alt_text": "Living and dining area with a sofa, coffee table, and dining set.",
        "public_id": "019fb34e-d856-700a-83a1-f49c91be0ecb",
        "storage_key": "property/6737460151191764/019fb34e-d856-700a-83a1-f49c91be0ecb.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furnishings, including a comfortable sofa, a stylish coffee table, and a dining set perfect for entertaining.",
      "link": "",
      "alt_text": "Living and dining area with a sofa, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6ae3236-8251-433c-9b16-3a0cb5466b42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-dbd0-779e-b059-60a75025436e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb34e-dbd0-779e-b059-60a75025436e",
        "storage_key": "property/6737460151191764/019fb34e-dbd0-779e-b059-60a75025436e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring white cabinetry, sleek granite countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c9c5342-0435-47ea-b70a-e1dfd22cd6ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-dbda-744e-b17e-0ef95e4267fa.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and wall decor",
        "public_id": "019fb34e-dbda-744e-b17e-0ef95e4267fa",
        "storage_key": "property/6737460151191764/019fb34e-dbda-744e-b17e-0ef95e4267fa.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a queen-size bed with plush bedding, a stylish nightstand with a lamp, and a decorative mirror arrangement on the wall.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and wall decor",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9570f0a6-ad55-4feb-9930-3e03ff75a484",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-dbe7-77cd-8ee8-afb2e7acb4e2.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees under a clear blue sky.",
        "public_id": "019fb34e-dbe7-77cd-8ee8-afb2e7acb4e2",
        "storage_key": "property/6737460151191764/019fb34e-dbe7-77cd-8ee8-afb2e7acb4e2.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_decfa5fe-bf90-40a9-8ed8-131bcd4ce428",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-db88-75a9-a488-e403ef2fa271.webp",
      "image_media": {
        "alt_text": "Clubhouse common area with seating, dining table, and bar.",
        "public_id": "019fb34e-db88-75a9-a488-e403ef2fa271",
        "storage_key": "property/6737460151191764/019fb34e-db88-75a9-a488-e403ef2fa271.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our spacious clubhouse common area, perfect for socializing or enjoying a quiet moment. Features comfortable seating, a dining area, and a convenient bar.",
      "link": "",
      "alt_text": "Clubhouse common area with seating, dining table, and bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fba5d081-a3c5-473e-8c77-dc262f867df1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-d800-757d-a199-9b42393a8b28.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a ceiling fan.",
        "public_id": "019fb34e-d800-757d-a199-9b42393a8b28",
        "storage_key": "property/6737460151191764/019fb34e-d800-757d-a199-9b42393a8b28.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with plush bedding, two nightstands, and a ceiling fan for comfort. The room is decorated with modern art and tasteful curtains.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4d0516d-aec8-444d-9820-24664fe5f498",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-d7fd-74ce-980d-876738d2b13c.webp",
      "image_media": {
        "alt_text": "Empty room with beige walls, a ceiling fan, and wood-look flooring.",
        "public_id": "019fb34e-d7fd-74ce-980d-876738d2b13c",
        "storage_key": "property/6737460151191764/019fb34e-d7fd-74ce-980d-876738d2b13c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "An empty room featuring a ceiling fan and stylish wood-look flooring, ready for you to make it your own.",
      "link": "",
      "alt_text": "Empty room with beige walls, a ceiling fan, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4df335b-9d73-4909-98fa-642482b9e1f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-d768-7121-9b9a-6b425fc6064b.webp",
      "image_media": {
        "alt_text": "Empty living room with gray walls and wood-look flooring.",
        "public_id": "019fb34e-d768-7121-9b9a-6b425fc6064b",
        "storage_key": "property/6737460151191764/019fb34e-d768-7121-9b9a-6b425fc6064b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room featuring neutral gray walls, modern wood-look flooring, and a ceiling light fixture.",
      "link": "",
      "alt_text": "Empty living room with gray walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a2ec159-d666-4c8d-842b-b11a4b30936c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019fb34e-dbdd-714e-bfc4-a41d427d52f6.webp",
      "image_media": {
        "alt_text": "Washer and dryer in apartment hallway",
        "public_id": "019fb34e-dbdd-714e-bfc4-a41d427d52f6",
        "storage_key": "property/6737460151191764/019fb34e-dbdd-714e-bfc4-a41d427d52f6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer located in a hallway, convenient for apartment residents.",
      "link": "",
      "alt_text": "Washer and dryer in apartment hallway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_54c9ae54-a3cc-4df1-a525-5266d7e8e160",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-f71d-76ff-9a38-380b15fa1a93.webp",
      "image_media": {
        "alt_text": "A paved walkway leads through a grassy courtyard lined with trees between apartment buildings.",
        "public_id": "019e8492-f71d-76ff-9a38-380b15fa1a93",
        "storage_key": "property/6737460151191764/019e8492-f71d-76ff-9a38-380b15fa1a93.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a stroll through the beautifully maintained courtyards, featuring lush greenery and mature trees, providing a serene atmosphere.",
      "link": "",
      "alt_text": "A paved walkway leads through a grassy courtyard lined with trees between apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66c8377a-97e4-45dd-b7f3-ce7f0ce9d771",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-eb3a-71f8-af67-b3fd12e32a32.webp",
      "image_media": {
        "alt_text": "Playground with swings, slides, and climbing structures in front of apartment buildings.",
        "public_id": "019e8492-eb3a-71f8-af67-b3fd12e32a32",
        "storage_key": "property/6737460151191764/019e8492-eb3a-71f8-af67-b3fd12e32a32.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring swings, slides, and climbing structures perfect for children.",
      "link": "",
      "alt_text": "Playground with swings, slides, and climbing structures in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be0512d3-52b2-4793-88eb-7499d23a76c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-e5f8-76a1-80a2-c21aa50bffd4.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings.",
        "public_id": "019e8492-e5f8-76a1-80a2-c21aa50bffd4",
        "storage_key": "property/6737460151191764/019e8492-e5f8-76a1-80a2-c21aa50bffd4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a slide and swings.",
      "link": "",
      "alt_text": "Playground with slides and swings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b3ca0241-4c49-4d01-9cbf-a984cbe9ba57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-cc99-738c-959c-c231eeb23095.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with trees and a sidewalk.",
        "public_id": "019e8492-cc99-738c-959c-c231eeb23095",
        "storage_key": "property/6737460151191764/019e8492-cc99-738c-959c-c231eeb23095.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with manicured lawns, mature trees, and a clear blue sky. A paved walkway leads along the side of the buildings.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with trees and a sidewalk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1bdd5468-965f-45db-a98f-d612ab0cd8fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-b475-7610-8519-f98fe1dcb131.webp",
      "image_media": {
        "alt_text": "Exterior of the building entrance at Ridgewood Apartments with a sign listing hours.",
        "public_id": "019e8492-b475-7610-8519-f98fe1dcb131",
        "storage_key": "property/6737460151191764/019e8492-b475-7610-8519-f98fe1dcb131.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the Ridgewood Apartments building entrance. This is a great place to start your tour of our community.",
      "link": "",
      "alt_text": "Exterior of the building entrance at Ridgewood Apartments with a sign listing hours.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fcf792f6-a23a-4ce1-8617-b5988e03225c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-ba77-7508-998e-81d1302e0e7c.webp",
      "image_media": {
        "alt_text": "Exterior buildings with brick and siding, surrounded by green grass and trees.",
        "public_id": "019e8492-ba77-7508-998e-81d1302e0e7c",
        "storage_key": "property/6737460151191764/019e8492-ba77-7508-998e-81d1302e0e7c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with well-maintained grounds.",
      "link": "",
      "alt_text": "Exterior buildings with brick and siding, surrounded by green grass and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_240f1fca-b407-453f-a223-fd960ee5cf04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-b481-7768-aa6c-c745f06e3c98.webp",
      "image_media": {
        "alt_text": "Outdoor recreational area with chess table, ping pong table, and foosball table, with apartment buildings in the background.",
        "public_id": "019e8492-b481-7768-aa6c-c745f06e3c98",
        "storage_key": "property/6737460151191764/019e8492-b481-7768-aa6c-c745f06e3c98.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun and games at our community's recreational area, featuring a chess table, ping pong table, and foosball table.",
      "link": "",
      "alt_text": "Outdoor recreational area with chess table, ping pong table, and foosball table, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5dc10ea7-1129-4e32-b2ac-7168ac285d9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-ba9f-72ac-a499-7c83276a49cc.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with manicured landscaping and sidewalk.",
        "public_id": "019e8492-ba9f-72ac-a499-7c83276a49cc",
        "storage_key": "property/6737460151191764/019e8492-ba9f-72ac-a499-7c83276a49cc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A charming exterior view of the apartment building, showcasing well-maintained landscaping and a welcoming sidewalk.",
      "link": "",
      "alt_text": "Exterior view of apartment building with manicured landscaping and sidewalk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03f5b96d-5908-4bab-ba49-800500716a98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-af71-76f4-b749-a0f5310162ca.webp",
      "image_media": {
        "alt_text": "Ridgewood Apartment Homes monument sign with landscaping.",
        "public_id": "019e8492-af71-76f4-b749-a0f5310162ca",
        "storage_key": "property/6737460151191764/019e8492-af71-76f4-b749-a0f5310162ca.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Ridgewood Apartment Homes, a premier apartment community surrounded by lush landscaping and mature trees. View our amenities and floor plans.",
      "link": "",
      "alt_text": "Ridgewood Apartment Homes monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51fcf376-b5ca-4652-bef4-70c7a02bb439",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-abbc-7489-af4e-2055f1319212.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with a winding sidewalk and lush landscaping.",
        "public_id": "019e8492-abbc-7489-af4e-2055f1319212",
        "storage_key": "property/6737460151191764/019e8492-abbc-7489-af4e-2055f1319212.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a well-maintained sidewalk leading to the entrance. Surrounded by green grass and mature trees, this property offers a peaceful living environment.",
      "link": "",
      "alt_text": "Exterior of apartment building with a winding sidewalk and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24a4679c-df1e-44c1-8892-a238d8ddd500",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-ad43-7219-b209-6a0c6c99a5c2.webp",
      "image_media": {
        "alt_text": "Outdoor recreational area with picnic tables, ping pong table, and playground.",
        "public_id": "019e8492-ad43-7219-b209-6a0c6c99a5c2",
        "storage_key": "property/6737460151191764/019e8492-ad43-7219-b209-6a0c6c99a5c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun with picnic areas, a ping pong table, and a playground, perfect for family gatherings and recreation.",
      "link": "",
      "alt_text": "Outdoor recreational area with picnic tables, ping pong table, and playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9cbe9062-3db6-4e85-895e-b733250ff37b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-a751-76a8-93a3-e0eea595eea5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with green and white siding, brick accents, and manicured landscaping.",
        "public_id": "019e8492-a751-76a8-93a3-e0eea595eea5",
        "storage_key": "property/6737460151191764/019e8492-a751-76a8-93a3-e0eea595eea5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a mix of green and white siding, accented by brick detailing. Surrounded by lush greenery and well-maintained landscaping for a welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment building with green and white siding, brick accents, and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da7a2ba0-b01c-4949-90e2-1010c2b66d28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-8dd1-70f9-82ec-f3dd434fd58c.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, dresser, and bedside table.",
        "public_id": "019e8492-8dd1-70f9-82ec-f3dd434fd58c",
        "storage_key": "property/6737460151191764/019e8492-8dd1-70f9-82ec-f3dd434fd58c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom featuring a plush queen-size bed, ample dresser storage, and a stylish bedside table.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, dresser, and bedside table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a9f4ef9c-a0a0-49c0-9f22-5d06fe6ae301",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-8e3a-733b-911d-bfc4c22414b5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with brick and green siding, manicured bushes, and a walkway.",
        "public_id": "019e8492-8e3a-733b-911d-bfc4c22414b5",
        "storage_key": "property/6737460151191764/019e8492-8e3a-733b-911d-bfc4c22414b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming exterior of the apartment building, featuring a mix of brick and green siding. Well-maintained landscaping with lush bushes and a clean walkway.",
      "link": "",
      "alt_text": "Exterior view of apartment building with brick and green siding, manicured bushes, and a walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6ce74b9-b827-45f5-a000-3c07bfa26c26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-90ac-77f3-b292-bce3957b8108.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan.",
        "public_id": "019e8492-90ac-77f3-b292-bce3957b8108",
        "storage_key": "property/6737460151191764/019e8492-90ac-77f3-b292-bce3957b8108.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A comfortable bedroom featuring a plush queen-size bed with blue and white bedding, a modern nightstand with a decorative lamp, and a large window with blue-patterned curtains.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7dab06cc-c420-4f4d-8c20-4bb5d09965c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-8ddf-7690-9138-1597adf59177.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, nightstands, and a ceiling fan.",
        "public_id": "019e8492-8ddf-7690-9138-1597adf59177",
        "storage_key": "property/6737460151191764/019e8492-8ddf-7690-9138-1597adf59177.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this comfortable and stylish bedroom, featuring a plush king-size bed, ample storage, and a ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_09d2b15a-7e30-4f27-ab19-fa14065777d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-8b22-737c-9799-8016b78cddab.webp",
      "image_media": {
        "alt_text": "Two empty closets with shelving and hanging rods.",
        "public_id": "019e8492-8b22-737c-9799-8016b78cddab",
        "storage_key": "property/6737460151191764/019e8492-8b22-737c-9799-8016b78cddab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closets with built-in shelving and hanging space provide ample storage.",
      "link": "",
      "alt_text": "Two empty closets with shelving and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6c493ff-7915-4796-a749-585a60b6eefe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-8a05-749d-b1a0-4c016c24f19a.webp",
      "image_media": {
        "alt_text": "View of a bathroom with two blue towels hanging on a rack and a toilet.",
        "public_id": "019e8492-8a05-749d-b1a0-4c016c24f19a",
        "storage_key": "property/6737460151191764/019e8492-8a05-749d-b1a0-4c016c24f19a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a toilet, two blue towels, and a built-in closet for storage.",
      "link": "",
      "alt_text": "View of a bathroom with two blue towels hanging on a rack and a toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5af2d52e-d3ba-4851-8ba7-05f7d9b3f079",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-83bc-77be-9de4-d23891eabc51.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
        "public_id": "019e8492-83bc-77be-9de4-d23891eabc51",
        "storage_key": "property/6737460151191764/019e8492-83bc-77be-9de4-d23891eabc51.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a large dresser with a decorative mirror, and a modern ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cf3e3e4a-4863-4d5a-8c48-5404ec8239ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-896b-743d-a493-a5a10fdbdade.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, sink, faucet, mirror, and light fixture. Includes framed artwork.",
        "public_id": "019e8492-896b-743d-a493-a5a10fdbdade",
        "storage_key": "property/6737460151191764/019e8492-896b-743d-a493-a5a10fdbdade.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom vanity featuring a granite countertop, undermount sink, and brushed nickel faucet. A large mirror with a vanity light fixture above complements the space. Framed artwork adds a decorative touch.",
      "link": "",
      "alt_text": "Bathroom vanity with granite countertop, sink, faucet, mirror, and light fixture. Includes framed artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f61794c5-a1aa-4548-94b3-adb49d61a3a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-89b8-7239-95a0-d73fb55b3908.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower, and towel.",
        "public_id": "019e8492-89b8-7239-95a0-d73fb55b3908",
        "storage_key": "property/6737460151191764/019e8492-89b8-7239-95a0-d73fb55b3908.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in the comfortable bathroom, featuring a spacious bathtub and shower.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, shower, and towel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b7f685f-81db-4e30-9ed1-915805ef9bdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-87ec-75d5-9bd1-cbfa0c9dfa9d.webp",
      "image_media": {
        "alt_text": "Treadmills and exercise machines in a well-lit fitness center.",
        "public_id": "019e8492-87ec-75d5-9bd1-cbfa0c9dfa9d",
        "storage_key": "property/6737460151191764/019e8492-87ec-75d5-9bd1-cbfa0c9dfa9d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, ellipticals, and weight machines.",
      "link": "",
      "alt_text": "Treadmills and exercise machines in a well-lit fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_830b0e83-0c15-4e3e-8ed8-12ba18bb79fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-445a-7020-8b72-80bc0825d66b.webp",
      "image_media": {
        "alt_text": "Business center with a desk, computer, and a high-top table with two chairs.",
        "public_id": "019e8492-445a-7020-8b72-80bc0825d66b",
        "storage_key": "property/6737460151191764/019e8492-445a-7020-8b72-80bc0825d66b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize the on-site business center, complete with a computer and desk, and a high-top table perfect for quick meetings.",
      "link": "",
      "alt_text": "Business center with a desk, computer, and a high-top table with two chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0c3fc5f-4dc6-4fe4-9ec3-ec16175cdd7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-4851-7733-b1d6-a25533c8f995.webp",
      "image_media": {
        "alt_text": "A living room featuring a white sofa, armchair, coffee table, and a large decorative mirror.",
        "public_id": "019e8492-4851-7733-b1d6-a25533c8f995",
        "storage_key": "property/6737460151191764/019e8492-4851-7733-b1d6-a25533c8f995.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room with modern furnishings, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "A living room featuring a white sofa, armchair, coffee table, and a large decorative mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2516ffb-98fb-4381-b4cc-b543c65312b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-3d43-77a6-a752-3428844352ab.webp",
      "image_media": {
        "alt_text": "Clubhouse dining area with a round table and four chairs.",
        "public_id": "019e8492-3d43-77a6-a752-3428844352ab",
        "storage_key": "property/6737460151191764/019e8492-3d43-77a6-a752-3428844352ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the comfortable and stylish clubhouse dining area, perfect for gatherings or a quiet meal.",
      "link": "",
      "alt_text": "Clubhouse dining area with a round table and four chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9cefea4c-98d2-48b6-9a9d-98d4824208a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-42cd-75fe-b5e3-89235e601152.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a well-lit fitness center with large windows.",
        "public_id": "019e8492-42cd-75fe-b5e3-89235e601152",
        "storage_key": "property/6737460151191764/019e8492-42cd-75fe-b5e3-89235e601152.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio machines to help you reach your wellness goals.",
      "link": "",
      "alt_text": "Treadmills and elliptical machines in a well-lit fitness center with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e744d789-2b9a-4eb5-afd3-7a5ad3b48295",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-6315-754f-a90b-42d937b17a5d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black subway tile backsplash, and granite countertops.",
        "public_id": "019e8492-6315-754f-a90b-42d937b17a5d",
        "storage_key": "property/6737460151191764/019e8492-6315-754f-a90b-42d937b17a5d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gleaming white cabinets, elegant granite countertops, and a stylish black subway tile backsplash create a sophisticated culinary space.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black subway tile backsplash, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0bdd2874-4b02-4f61-8b82-f98471f8da63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-370d-749d-b253-ead7f64784f7.webp",
      "image_media": {
        "alt_text": "A staged living room and dining area with white sofas, teal dining chairs, and modern decor.",
        "public_id": "019e8492-370d-749d-b253-ead7f64784f7",
        "storage_key": "property/6737460151191764/019e8492-370d-749d-b253-ead7f64784f7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living and dining area, perfect for relaxing and entertaining. Features comfortable seating and a stylish dining set.",
      "link": "",
      "alt_text": "A staged living room and dining area with white sofas, teal dining chairs, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a32eae7d-1836-4289-8b27-07c5cfde1322",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-3259-7476-86ba-322052568a25.webp",
      "image_media": {
        "alt_text": "Modern lounge area with grey chaise, teal armchairs, and coffee table.",
        "public_id": "019e8492-3259-7476-86ba-322052568a25",
        "storage_key": "property/6737460151191764/019e8492-3259-7476-86ba-322052568a25.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and a welcoming atmosphere. Perfect for residents to socialize or find a quiet moment.",
      "link": "",
      "alt_text": "Modern lounge area with grey chaise, teal armchairs, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0801f936-9eb2-461d-9a16-0052e09ed6e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-1f8f-712a-b33a-83be9a8d4bc1.webp",
      "image_media": {
        "alt_text": "Elliptical machines, stair climber, and weight machine in a modern gym.",
        "public_id": "019e8492-1f8f-712a-b33a-83be9a8d4bc1",
        "storage_key": "property/6737460151191764/019e8492-1f8f-712a-b33a-83be9a8d4bc1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines and weight training equipment for a complete workout.",
      "link": "",
      "alt_text": "Elliptical machines, stair climber, and weight machine in a modern gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c34e4d19-e5de-40ac-bfa5-a8d627e2d2a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-1899-72dd-a212-ad9a2e633c9f.webp",
      "image_media": {
        "alt_text": "Kitchenette area with a high-top table and chairs, refrigerator, microwave, and cabinetry.",
        "public_id": "019e8492-1899-72dd-a212-ad9a2e633c9f",
        "storage_key": "property/6737460151191764/019e8492-1899-72dd-a212-ad9a2e633c9f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy convenient amenities in our community kitchenette, featuring a refrigerator, microwave, and ample counter space. A stylish table and chairs provide a perfect spot for a quick bite or casual meeting.",
      "link": "",
      "alt_text": "Kitchenette area with a high-top table and chairs, refrigerator, microwave, and cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29d418e4-2b18-4e60-8fd0-4f2af3020c8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-1056-72cb-90a3-cf7c8b015a4c.webp",
      "image_media": {
        "alt_text": "Front desk area with a wooden desk, two chairs, and artwork on the wall.",
        "public_id": "019e8492-1056-72cb-90a3-cf7c8b015a4c",
        "storage_key": "property/6737460151191764/019e8492-1056-72cb-90a3-cf7c8b015a4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing office! Our friendly staff is ready to assist you with finding your new home.",
      "link": "",
      "alt_text": "Front desk area with a wooden desk, two chairs, and artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9be329d6-ed7f-40f8-9d25-141eca9b60e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-42ce-74b4-a55b-7618662f1e85.webp",
      "image_media": {
        "alt_text": "View into a bathroom with light blue towels hanging on a rack. Carpeted hallway with closets on either side.",
        "public_id": "019e8492-42ce-74b4-a55b-7618662f1e85",
        "storage_key": "property/6737460151191764/019e8492-42ce-74b4-a55b-7618662f1e85.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a well-appointed bathroom, complete with plush towels and modern finishes. The adjacent hallway offers ample closet space.",
      "link": "",
      "alt_text": "View into a bathroom with light blue towels hanging on a rack. Carpeted hallway with closets on either side.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_257f17d6-cbb7-4ecb-aa0f-bbf2f28e9306",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-2637-75bb-8b39-6f6371dcf4d2.webp",
      "image_media": {
        "alt_text": "Dining room with a round glass table, four blue chairs, and modern artwork.",
        "public_id": "019e8492-2637-75bb-8b39-6f6371dcf4d2",
        "storage_key": "property/6737460151191764/019e8492-2637-75bb-8b39-6f6371dcf4d2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy stylish dining in this apartment's dedicated dining area, perfect for meals with friends and family.",
      "link": "",
      "alt_text": "Dining room with a round glass table, four blue chairs, and modern artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7c401168-29fb-41b1-946d-7783e7534c6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e8492-0754-7691-8855-489d8f7c6471.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, coffee table, TV, and sideboard.",
        "public_id": "019e8492-0754-7691-8855-489d8f7c6471",
        "storage_key": "property/6737460151191764/019e8492-0754-7691-8855-489d8f7c6471.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic living room featuring a comfortable white sofa, a modern coffee table, a mounted television, and a stylish wooden sideboard.",
      "link": "",
      "alt_text": "Living room with white sofa, coffee table, TV, and sideboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d283fee8-5e19-463c-bf7a-44ec53752273",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Asia Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11812 Middleground Rd #300, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-882e-717c-8c3f-551c10d91411.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-882e-717c-8c3f-551c10d91411",
        "storage_key": "property/6737460151191764/019e1e3c-882e-717c-8c3f-551c10d91411.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4739696818678633789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asia-restaurant",
      "poi_latitude": "31.9874602",
      "poi_longitude": "-81.1582542",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-961-0281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQFPKMx0-4gRPZVjBCXJxkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_134926cc-3544-48cb-8ff7-9f4cb6428895",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "The Hideaway Cafe",
      "poi_type": "Restaurants",
      "poi_address": "105 Tibet Ave, Savannah, GA 31406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-8c26-76ad-8933-d4933dc04d06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-8c26-76ad-8933-d4933dc04d06",
        "storage_key": "property/6737460151191764/019e1e3c-8c26-76ad-8933-d4933dc04d06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thehideawaycafesav.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12801697646067963805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hideaway-cafe",
      "poi_latitude": "31.9885877",
      "poi_longitude": "-81.13227650000002",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-777-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8PHsm51-4gRndfVyy7EqLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bf19c4cc-1aa4-459e-acb3-48f6e79dd02d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Troy Mediterranean Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "10510 Abercorn St STE D, Savannah, GA 31419, USA",
      "poi_short_description": "Cheerful restaurant offering a broad Mediterranean menu that includes kebabs, falafel & seafood.",
      "poi_long_description": "Cheerful restaurant offering a broad Mediterranean menu that includes kebabs, falafel & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-946a-7421-95f9-30919bf2c778.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-946a-7421-95f9-30919bf2c778",
        "storage_key": "property/6737460151191764/019e1e3c-946a-7421-95f9-30919bf2c778.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://troymediterraneancuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1429619318984124613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "troy-mediterranean-cuisine",
      "poi_latitude": "31.9853357",
      "poi_longitude": "-81.1315637",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-921-5117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdR7MN-50-4gRxagVODIH1xM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_02349dd7-1103-4f1b-861c-18976ad41032",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "10408 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-8705-7119-82cd-31eb46c5219c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-8705-7119-82cd-31eb46c5219c",
        "storage_key": "property/6737460151191764/019e1e3c-8705-7119-82cd-31eb46c5219c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.carrabbas.com/georgia/savannah/10408-abercorn-street?y_source=1_MTU1MDI5ODUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4313380771380680115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrabbas-italian-grill",
      "poi_latitude": "31.9874743",
      "poi_longitude": "-81.1307999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-961-7073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVoeR-50-4gRs1UlU_U03Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1c6b8e98-ce89-4fcf-b65a-c91af7a10690",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11333 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-529f-7149-9030-505781e77f7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-529f-7149-9030-505781e77f7a",
        "storage_key": "property/6737460151191764/019e1e3a-529f-7149-9030-505781e77f7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ga/savannah/savannah-abercorn-street/1529?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:savannah-ga-1529_pl:locurl_rd:1399",
      "poi_directions_map_url": "https://maps.google.com/?cid=546195667367978345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "31.980543",
      "poi_longitude": "-81.147307",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-961-9009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-V008B0-4gRaWVTyxB6lAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_6193f543-9f37-4175-90ae-f5a183300842",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "11196 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-8c80-731b-8adf-1301cfccb044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-8c80-731b-8adf-1301cfccb044",
        "storage_key": "property/6737460151191764/019e1e3c-8c80-731b-8adf-1301cfccb044.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.outback.com/georgia/savannah/11196-abercorn-street?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDIwOTUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10405101028150204075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "31.981075",
      "poi_longitude": "-81.14538259999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-920-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_bKQnoJ-4gRq9bxqkFYZpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_cc9c057b-70ad-4caa-ab8e-fd3a6d9b9f14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Carey Hilliard's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11111 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "One of a local chain of family drive-ups (with indoor dining too) for BBQ, seafood & Southern eats.",
      "poi_long_description": "One of a local chain of family drive-ups (with indoor dining too) for BBQ, seafood & Southern eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-8950-71c4-9bbd-258549ebc430.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-8950-71c4-9bbd-258549ebc430",
        "storage_key": "property/6737460151191764/019e1e3c-8950-71c4-9bbd-258549ebc430.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://careyhilliards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17763319447254997600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carey-hilliards-restaurant",
      "poi_latitude": "31.9793683",
      "poi_longitude": "-81.14260519999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-925-3225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEb4IXMB0-4gRYBpsVez8g_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ffcdf5a8-0f80-4b87-a9e5-87afcc4e6243",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "11120 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-8d4e-72a4-b232-14e1f9493791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-8d4e-72a4-b232-14e1f9493791",
        "storage_key": "property/6737460151191764/019e1e3c-8d4e-72a4-b232-14e1f9493791.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/ga/savannah/11120-abercorn-84038?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=84038&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7555779328131839626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "applebees-grill--bar",
      "poi_latitude": "31.9803736",
      "poi_longitude": "-81.14274809999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-920-7966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtfFkOcB0-4gRiraJRkSF22g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f598a67d-8c8a-462f-a5f3-bb0ff3ecdd42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "11152 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-888d-766a-9b31-72ec8395f1bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-888d-766a-9b31-72ec8395f1bd",
        "storage_key": "property/6737460151191764/019e1e3c-888d-766a-9b31-72ec8395f1bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/abercorn?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17783773297571893405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "31.9805771",
      "poi_longitude": "-81.14371229999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-921-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf45xW8B0-4gRnZDZd5enzPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_cae8b5a2-2667-4cb6-bf55-9a92e457ef99",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Parker's Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10525 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-87d5-709b-8882-c48d4eb91c1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-87d5-709b-8882-c48d4eb91c1a",
        "storage_key": "property/6737460151191764/019e1e3c-87d5-709b-8882-c48d4eb91c1a.webp",
        "width": 1280,
        "height": 507
      },
      "poi_business_url": "https://parkerskitchen.com/locations/parkers-29/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17475526863330333149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkers-kitchen",
      "poi_latitude": "31.984078",
      "poi_longitude": "-81.13318199999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-921-1899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e042-76cd-b405-63a6038501ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e042-76cd-b405-63a6038501ab",
        "storage_key": "property/6737460151191764/019e1e3c-e042-76cd-b405-63a6038501ab.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJhVC_ae50-4gR3dGZxxeLhfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_41564b87-ead0-476f-9aae-1c406d5c21f9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Seasons of Japan",
      "poi_type": "Restaurants",
      "poi_address": "7923 White Bluff Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Contemporary counter-serve eatery with a simple selection of hibachi-style Japanese fare & sushi.",
      "poi_long_description": "Contemporary counter-serve eatery with a simple selection of hibachi-style Japanese fare & sushi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-92bc-7259-b024-eec68702aaea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-92bc-7259-b024-eec68702aaea",
        "storage_key": "property/6737460151191764/019e1e3c-92bc-7259-b024-eec68702aaea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://seasonsofjapan.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3267487949180971935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seasons-of-japan",
      "poi_latitude": "32.0028732",
      "poi_longitude": "-81.1210517",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-401-1925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5_4Px8F1-4gRnyvNVvpyWC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_da257a9b-4575-45ba-b69c-e49d8962fc8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "PERSIS INDIAN GRILL",
      "poi_type": "Restaurants",
      "poi_address": "101 S Godley Station Blvd Blv, Pooler, GA 31322, USA",
      "poi_short_description": "Tandoori dishes, Indian classics and vegan specialties served in a straightforward setting, with friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9650-77eb-be73-a15c22b6e701.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9650-77eb-be73-a15c22b6e701",
        "storage_key": "property/6737460151191764/019e1e3c-9650-77eb-be73-a15c22b6e701.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.persissavannah.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11006383645691260619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "persis-indian-grill",
      "poi_latitude": "32.1317573",
      "poi_longitude": "-81.2576265",
      "poi_miles_from_property": "23.4",
      "poi_walking_minutes": "8 hours 36 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 912-509-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9YLU7FKn-4gRy64Yh5yHvpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_7e37687f-29f0-4ed6-a1f8-9911600db710",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "The Toasted Yolk Cafe- Savannah",
      "poi_type": "Restaurants",
      "poi_address": "201 James B Blackburn Dr, Savannah, GA 31408, USA",
      "poi_short_description": "Cozy restaurant dishing up breakfast, lunch, and dinner, plus beer, wine, and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-983c-763d-8e3b-e801d0634d6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-983c-763d-8e3b-e801d0634d6e",
        "storage_key": "property/6737460151191764/019e1e3c-983c-763d-8e3b-e801d0634d6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thetoastedyolk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9775046096663846314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-toasted-yolk-cafe--savannah",
      "poi_latitude": "32.1376576",
      "poi_longitude": "-81.23196159999999",
      "poi_miles_from_property": "25.2",
      "poi_walking_minutes": "9 hours 15 mins",
      "poi_biking_minutes": "2 hours 13 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 912-556-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwayYdsSh-4gRqp23bqLwp4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ce3e723b-215a-473d-ab64-4d087522b068",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Green Fire Pizza & Sports Bar",
      "poi_type": "Restaurants",
      "poi_address": "1557 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Laid-back haunt with outdoor tables & TVs for sports offering pizzeria fare & classic bar food.",
      "poi_long_description": "Laid-back haunt with outdoor tables & TVs for sports offering pizzeria fare & classic bar food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-94d5-7404-8a09-07c469d24212.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-94d5-7404-8a09-07c469d24212",
        "storage_key": "property/6737460151191764/019e1e3c-94d5-7404-8a09-07c469d24212.webp",
        "width": 828,
        "height": 1035
      },
      "poi_business_url": "https://greenfirepizza.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17993162803635730645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-fire-pizza--sports-bar",
      "poi_latitude": "32.0921585",
      "poi_longitude": "-81.2742083",
      "poi_miles_from_property": "20.9",
      "poi_walking_minutes": "7 hours 43 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 912-988-3381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZhXNW-e-4gR1bh68DyOtPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_96a2de82-edf8-499e-9d90-c90e040cd3e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Wasabi Fusion",
      "poi_type": "Restaurants",
      "poi_address": "950 Morgans Corner Rd, Pooler, GA 31322, USA",
      "poi_short_description": "Low-key eatery serves Japanese & Asian dishes, such as noodle soups & sushi in unfussy digs.",
      "poi_long_description": "Low-key eatery serves Japanese & Asian dishes, such as noodle soups & sushi in unfussy digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-95d2-700c-a3ad-1a5552887314.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-95d2-700c-a3ad-1a5552887314",
        "storage_key": "property/6737460151191764/019e1e3c-95d2-700c-a3ad-1a5552887314.webp",
        "width": 1280,
        "height": 933
      },
      "poi_business_url": "http://wasabifusionpooler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3893880621564580360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasabi-fusion",
      "poi_latitude": "32.0987236",
      "poi_longitude": "-81.2702563",
      "poi_miles_from_property": "20.6",
      "poi_walking_minutes": "7 hours 35 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 912-450-0887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxkVkyCn-4gRCFIibsvXCTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_c2747583-5a28-4fa1-a24f-e26e6909fd71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Chu's Mart #114",
      "poi_type": "Shopping & Retail",
      "poi_address": "12006 Middleground Rd, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9596-774f-a829-32d0fe4406f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9596-774f-a829-32d0fe4406f3",
        "storage_key": "property/6737460151191764/019e1e3c-9596-774f-a829-32d0fe4406f3.webp",
        "width": 350,
        "height": 280
      },
      "poi_business_url": "http://www.chusmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9705031624584504856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chus-mart-114",
      "poi_latitude": "31.9858835",
      "poi_longitude": "-81.1612366",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-925-9806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e056-752b-82c0-09a7b004833b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e056-752b-82c0-09a7b004833b",
        "storage_key": "property/6737460151191764/019e1e3c-e056-752b-82c0-09a7b004833b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ6XbPgcx0-4gRGKZK1dcyr4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_c5be9863-25ef-47ec-aaf5-bbac02be88dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Chiles Verdes",
      "poi_type": "Shopping & Retail",
      "poi_address": "11812 Middleground Rd, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9a8c-7627-b5a2-c57945441e4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9a8c-7627-b5a2-c57945441e4c",
        "storage_key": "property/6737460151191764/019e1e3c-9a8c-7627-b5a2-c57945441e4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6968819421838312278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chiles-verdes",
      "poi_latitude": "31.9874542",
      "poi_longitude": "-81.158168",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-468-7051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-c924fb04edaf",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1i8B9Z1-4gRVgOEflc4tmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_66e1afac-87bb-4c90-8975-2e5d87bcc860",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10530 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Neighborhood chain supplying groceries, plus items such as electronics, furniture, and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9a89-7179-b409-23d768720f8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9a89-7179-b409-23d768720f8b",
        "storage_key": "property/6737460151191764/019e1e3c-9a89-7179-b409-23d768720f8b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/4530-savannah-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6767545055041216584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "31.9836499",
      "poi_longitude": "-81.1309838",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-712-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-c924fb04edaf",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQj7N-50-4gRSOAuH18m610",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e740c0f8-0ef6-4848-bad2-e41161783dbb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "10402 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9a23-7021-9706-bfb472f97d70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9a23-7021-9706-bfb472f97d70",
        "storage_key": "property/6737460151191764/019e1e3c-9a23-7021-9706-bfb472f97d70.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dollartree.com/ga/savannah/10402-abercorn-street?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4771916052616707416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "31.9883171",
      "poi_longitude": "-81.1302907",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-226-2570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ37bDmjF1-4gRWP0z_l1AOUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_0209b706-1030-41f7-a364-6753af3a66a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "The Guadalupana Mexican grocery & Restaurant",
      "poi_type": "Shopping & Retail",
      "poi_address": "6009 Ogeechee Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Grocery store with a selection of Mexican products including produce, tamales, and tacos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9e34-72eb-8167-618b63f37118.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9e34-72eb-8167-618b63f37118",
        "storage_key": "property/6737460151191764/019e1e3c-9e34-72eb-8167-618b63f37118.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1191733755388430794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-guadalupana-mexican-grocery--restaurant",
      "poi_latitude": "31.9969099",
      "poi_longitude": "-81.2605131",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-349-5617",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-c924fb04edaf",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_rBVZUJ-4gRygnFVInjiRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_81622d12-964b-4c58-ab3b-3801d14b9bda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Enson Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5501 Abercorn St, Savannah, GA 31405, USA",
      "poi_short_description": "Grocery stocking produce, seafood and meats alongside Asian goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-4e3c-730a-93a2-9295c983d7f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-4e3c-730a-93a2-9295c983d7f1",
        "storage_key": "property/6737460151191764/019e1e3a-4e3c-730a-93a2-9295c983d7f1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://ensonmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7855261888996385765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enson-market",
      "poi_latitude": "32.0268437",
      "poi_longitude": "-81.10985339999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-206-6118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-c924fb04edaf",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW4OBhEx1-4gR5SNLrxF_A20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_9d1e9b2f-3ece-41d6-83c3-edc7078e3164",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Publix Super Market at Largo Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "11701 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9e37-72bd-a93a-03c975fab6c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9e37-72bd-a93a-03c975fab6c2",
        "storage_key": "property/6737460151191764/019e1e3c-9e37-72bd-a93a-03c975fab6c2.webp",
        "width": 1280,
        "height": 911
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1186&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=6342669933370170470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-largo-plaza",
      "poi_latitude": "31.9813532",
      "poi_longitude": "-81.15211",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-925-4112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-c924fb04edaf",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVasScZ0-4gRZlwUErOwBVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_f04f15d8-2131-4b20-becc-d200a2c0277e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "318 Mall Blvd Suite 100, Savannah, GA 31406, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-4d0e-772b-9277-1dfde75d7263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-4d0e-772b-9277-1dfde75d7263",
        "storage_key": "property/6737460151191764/019e1e3a-4d0e-772b-9277-1dfde75d7263.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/savannah/savannah-marketwalk/011/00697?cid=loc_01100697_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15465656371393964293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "32.0063117",
      "poi_longitude": "-81.112933",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-200-9158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-c924fb04edaf",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6V7_EKx1-4gRBakxe4cModY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dfb86c5b-0113-4d38-a521-ddd78709e5ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6000 Ogeechee Rd, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9ed2-7369-95b8-f78d7d586aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9ed2-7369-95b8-f78d7d586aef",
        "storage_key": "property/6737460151191764/019e1e3c-9ed2-7369-95b8-f78d7d586aef.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/635-savannah-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6290411511737980263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "31.9997116",
      "poi_longitude": "-81.2579061",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-921-0882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD_XrrGQJ-4gRZ5UrIPEHTFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_be06365d-5c59-4420-af8f-2ef0859b528c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "St. Frances Cabrini Catholic School",
      "poi_type": "Education",
      "poi_address": "11500 Middleground Rd, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cabrini-sav.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13415569505017675193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-frances-cabrini-catholic-school",
      "poi_latitude": "31.9884539",
      "poi_longitude": "-81.1568767",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 912-925-4725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwSe_Fc50-4gRuT0k1mKtLbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_cec8a672-0327-43f3-9c8a-ea749113d34e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Windsor Forest High School",
      "poi_type": "Education",
      "poi_address": "12419 Largo Dr, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://spwww.sccpss.com/schools/wfhs/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17287387800476265407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windsor-forest-high-school",
      "poi_latitude": "31.9764814",
      "poi_longitude": "-81.15294109999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-395-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ07kIXrh0-4gRvyvPrZwj6e8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c7797dfa-c61f-4cc1-a529-960be23e6156",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Windsor Forest Elementary School",
      "poi_type": "Education",
      "poi_address": "414 Briarcliff Cir, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18059267086944454536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windsor-forest-elementary-school",
      "poi_latitude": "31.9747442",
      "poi_longitude": "-81.1447711",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-395-3353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc1z1Yr50-4gRiEc6xbtnn_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7e4554e9-79ca-4128-a7c6-9fc21502033e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Pulaski Elementary School",
      "poi_type": "Education",
      "poi_address": "1001 Tibet Ave, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pulaski.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=792347744620775941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pulaski-elementary-school",
      "poi_latitude": "31.9967775",
      "poi_longitude": "-81.1555534",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 912-395-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLyR6lBl1-4gRBQq0YBP8_go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5c81b11e-ad45-437b-9fe3-fb7c3c65826d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Georgetown School k-8",
      "poi_type": "Education",
      "poi_address": "1516 King George Blvd, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-a1b3-77ea-91f3-110f9de927bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-a1b3-77ea-91f3-110f9de927bf",
        "storage_key": "property/6737460151191764/019e1e3c-a1b3-77ea-91f3-110f9de927bf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://gtown.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13293878039832909267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgetown-school-k-8",
      "poi_latitude": "31.9758732",
      "poi_longitude": "-81.22901089999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-395-3475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV8m8co0L-4gR01Wbq6RXfbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f574c0f7-c124-497a-b848-e0b8e4d31e14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Southwest Middle School",
      "poi_type": "Education",
      "poi_address": "6030 Ogeechee Rd, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://swms.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15577234606037299047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-middle-school",
      "poi_latitude": "31.9982769",
      "poi_longitude": "-81.2638077",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-395-3540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKUrp3vYJ-4gRZ2_Gq1d0Ldg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_27bd1064-7ee7-43c7-843a-e23b68812d14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Foundations Early Learning Center of Savannah",
      "poi_type": "Education",
      "poi_address": "5682 Ogeechee Rd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-a017-716d-9edf-ce3941517a7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-a017-716d-9edf-ce3941517a7c",
        "storage_key": "property/6737460151191764/019e1e3c-a017-716d-9edf-ce3941517a7c.webp",
        "width": 1200,
        "height": 628
      },
      "poi_business_url": "https://foundationsearlylearningcenter.com/savannah/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17107040752030207546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foundations-early-learning-center-of-savannah",
      "poi_latitude": "32.0318352",
      "poi_longitude": "-81.2201604",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-680-0230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl0xKAnIL-4gROk7kTu1qaO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_6b03a148-80a6-4e5d-a98e-c6888fa59caa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "A J Ward Montessori Preschool",
      "poi_type": "Education",
      "poi_address": "911 Dutchtown Rd, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-a273-7426-8a9d-a74b13bae1b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-a273-7426-8a9d-a74b13bae1b9",
        "storage_key": "property/6737460151191764/019e1e3c-a273-7426-8a9d-a74b13bae1b9.webp",
        "width": 1280,
        "height": 382
      },
      "poi_business_url": "https://www.ajwmontessori.com/aj-ward",
      "poi_directions_map_url": "https://maps.google.com/?cid=4389632242214431970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-j-ward-montessori-preschool",
      "poi_latitude": "31.9873656",
      "poi_longitude": "-81.1579527",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 912-925-4566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB0BZbSd1-4gR4uzKW0Qb6zw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_ee7cf86e-0d9e-4533-ae7d-1a3615aa1b16",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Georgia Southern University Armstrong Campus Savannah",
      "poi_type": "Education",
      "poi_address": "11935 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-581c-72f6-8740-325ed14b2766.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-581c-72f6-8740-325ed14b2766",
        "storage_key": "property/6737460151191764/019e1e3a-581c-72f6-8740-325ed14b2766.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.georgiasouthern.edu/campuses/armstrong-campus-savannah/",
      "poi_directions_map_url": "https://maps.google.com/?cid=783516353767565760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-southern-university-armstrong-campus-savannah",
      "poi_latitude": "31.9786073",
      "poi_longitude": "-81.1634639",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-478-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9h8y0oL-4gRwGkG9vib3wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_607e9498-b5df-49f6-bf9a-8bbc3c933b30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Savannah Technical College",
      "poi_type": "Education",
      "poi_address": "5717 White Bluff Rd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-54e7-76cb-bbf0-ea681ad16e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-54e7-76cb-bbf0-ea681ad16e5a",
        "storage_key": "property/6737460151191764/019e1e3a-54e7-76cb-bbf0-ea681ad16e5a.webp",
        "width": 1280,
        "height": 1079
      },
      "poi_business_url": "https://www.savannahtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7052498624589095008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-technical-college",
      "poi_latitude": "32.0235786",
      "poi_longitude": "-81.1141815",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-443-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdS0rI591-4gRYGCQISKC32E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2bd53426-102a-4df2-9c01-b7be9826b6b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Oatland Island Wildlife Center",
      "poi_type": "Entertainment",
      "poi_address": "711 Sandtown Rd, Savannah, GA 31410, USA",
      "poi_short_description": "Compact, zoo-like preserve with dozens of species in natural habitats, plus education programs.",
      "poi_long_description": "Compact, zoo-like preserve with dozens of species in natural habitats, plus education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-a57a-761c-93ed-fe4b996db7f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-a57a-761c-93ed-fe4b996db7f6",
        "storage_key": "property/6737460151191764/019e1e3c-a57a-761c-93ed-fe4b996db7f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oatland.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12055131803854154654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oatland-island-wildlife-center",
      "poi_latitude": "32.049159",
      "poi_longitude": "-81.02449969999999",
      "poi_miles_from_property": "14.2",
      "poi_walking_minutes": "5 hours 16 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 912-395-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKz5cUG6d-4gRnqs9OYFuTKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_park"
    },
    {
      "id": "custom_77ca5b81-f3ad-4331-a15f-cc9598d11f6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Wormsloe State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "7601 Skidaway Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Historic site featuring the ruins of a Colonial estate, gardens, trails & an oak-lined driveway.",
      "poi_long_description": "Historic site featuring the ruins of a Colonial estate, gardens, trails & an oak-lined driveway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-5caf-7278-be63-8f79f46cf521.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-5caf-7278-be63-8f79f46cf521",
        "storage_key": "property/6737460151191764/019e1e3a-5caf-7278-be63-8f79f46cf521.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gastateparks.org/Wormsloe",
      "poi_directions_map_url": "https://maps.google.com/?cid=10012291246731543177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wormsloe-state-historic-site",
      "poi_latitude": "31.9801601",
      "poi_longitude": "-81.0692663",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-353-3023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb",
        "storage_key": "property/6737460151191764/019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Ccw5x2-4gRicIvbdfN8oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_893fb76a-0844-4697-88b1-f01fccad42f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Skidaway Island State Park",
      "poi_type": "Entertainment",
      "poi_address": "52 Diamond Causeway, Savannah, GA 31411, USA",
      "poi_short_description": "A waterfront park offering camping (including cabins), nature programs, trails & a viewing tower.",
      "poi_long_description": "A waterfront park offering camping (including cabins), nature programs, trails & a viewing tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-aaf1-72da-bc68-6e5cf31302e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-aaf1-72da-bc68-6e5cf31302e9",
        "storage_key": "property/6737460151191764/019e1e3c-aaf1-72da-bc68-6e5cf31302e9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://gastateparks.org/SkidawayIsland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471744632454584550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skidaway-island-state-park",
      "poi_latitude": "31.95476559999999",
      "poi_longitude": "-81.0525755",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-598-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5TuGrZ2-4gR5hhn4Hhkl-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_42fd0c29-ec7d-4244-bdc8-83d7de76245d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "AMC CLASSIC Savannah 11",
      "poi_type": "Entertainment",
      "poi_address": "1150 Shawnee St, Savannah, GA 31420, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-aab1-733d-90f6-f9856f1797d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-aab1-733d-90f6-f9856f1797d8",
        "storage_key": "property/6737460151191764/019e1e3c-aab1-733d-90f6-f9856f1797d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/savannah-ga/amc-classic-savannah-11?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4847953490304313417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-classic-savannah-11",
      "poi_latitude": "31.9869643",
      "poi_longitude": "-81.17182729999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-920-3994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e058-76f9-867d-cdd9cef5949e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e058-76f9-867d-cdd9cef5949e",
        "storage_key": "property/6737460151191764/019e1e3c-e058-76f9-867d-cdd9cef5949e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4m4LjcL-4gRSSg0jQNkR0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_93957372-9247-44ab-90d1-318142333c88",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Lucas Theatre For the Arts",
      "poi_type": "Entertainment",
      "poi_address": "32 Abercorn St, Savannah, GA 31401, USA",
      "poi_short_description": "Revived 1920s theater hosts national & local stage productions, musical acts & film screenings.",
      "poi_long_description": "Revived 1920s theater hosts national & local stage productions, musical acts & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-a5d2-740b-ab71-6e47ca95cf65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-a5d2-740b-ab71-6e47ca95cf65",
        "storage_key": "property/6737460151191764/019e1e3c-a5d2-740b-ab71-6e47ca95cf65.webp",
        "width": 1280,
        "height": 951
      },
      "poi_business_url": "https://www.lucastheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14397539329963391563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucas-theatre-for-the-arts",
      "poi_latitude": "32.0788098",
      "poi_longitude": "-81.0892985",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-525-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQvlp2We-4gRS_ouOr1Vzsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_a40d06ca-73df-4e09-bf73-f59ee8c3e41b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Savannah Theatre",
      "poi_type": "Entertainment",
      "poi_address": "222 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_long_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-a5aa-71e8-8ac5-e8964c7bc74a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-a5aa-71e8-8ac5-e8964c7bc74a",
        "storage_key": "property/6737460151191764/019e1e3c-a5aa-71e8-8ac5-e8964c7bc74a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12411390908795783721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-theatre",
      "poi_latitude": "32.0758167",
      "poi_longitude": "-81.0924435",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-233-7764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTqMrmie-4gRKQpJ70UePqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_75c457a3-bea9-4509-9baa-ec2f1410f813",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Jepson Center & Telfair Children's Art Museum (CAM)",
      "poi_type": "Entertainment",
      "poi_address": "207 W York St, Savannah, GA 31401, USA",
      "poi_short_description": "Museum featuring modern paintings, photos & installations, plus an interactive gallery for kids.",
      "poi_long_description": "Museum featuring modern paintings, photos & installations, plus an interactive gallery for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-a722-7608-a9c9-69c74b61adf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-a722-7608-a9c9-69c74b61adf8",
        "storage_key": "property/6737460151191764/019e1e3c-a722-7608-a9c9-69c74b61adf8.webp",
        "width": 1280,
        "height": 1001
      },
      "poi_business_url": "http://www.telfair.org/visit/jepson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16733686102627315117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jepson-center--telfair-childrens-art-museum-cam",
      "poi_latitude": "32.0782855",
      "poi_longitude": "-81.0951522",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-790-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb",
        "storage_key": "property/6737460151191764/019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1g6smee-4gRre39-dn-Oeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_056ee096-22da-4cdc-ad51-efddfdfec2cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Savannah Civic Center",
      "poi_type": "Entertainment",
      "poi_address": "301 W Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "Venue hosting concerts and ice skating shows.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-ad40-74a0-833b-057f810ba835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-ad40-74a0-833b-057f810ba835",
        "storage_key": "property/6737460151191764/019e1e3c-ad40-74a0-833b-057f810ba835.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://savannahcivic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16051971994371006477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-civic-center",
      "poi_latitude": "32.07696",
      "poi_longitude": "-81.0969503",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-651-6550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8d3a-746b-8a0c-17daf996e6c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8d3a-746b-8a0c-17daf996e6c1",
        "storage_key": "property/6737460151191764/019e1e3a-8d3a-746b-8a0c-17daf996e6c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ_hJuFKf-4gRDaAAXXsPxN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_8c88cc63-d1fe-421f-9cbe-34a73a6081b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Forsyth Park",
      "poi_type": "Entertainment",
      "poi_address": "Savannah, GA 31401, USA",
      "poi_short_description": "30-acre park with basketball & tennis courts, paths, a historic fountain & a Confederate memorial.",
      "poi_long_description": "30-acre park with basketball & tennis courts, paths, a historic fountain & a Confederate memorial.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-ada9-7260-8dd5-8c07d88957c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-ada9-7260-8dd5-8c07d88957c3",
        "storage_key": "property/6737460151191764/019e1e3c-ada9-7260-8dd5-8c07d88957c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.savannahga.gov/351/Parks-Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=16070509674831716323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forsyth-park",
      "poi_latitude": "32.0675356",
      "poi_longitude": "-81.09623839999999",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-351-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj52mkmqe-4gR45_Sb2frBd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cce24ad6-d43b-4c89-9155-07b483b734da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Savannah Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "655 Louisville Rd, Savannah, GA 31401, USA",
      "poi_short_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_long_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-aa2e-729b-a8c6-35ba4dd2fb50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-aa2e-729b-a8c6-35ba4dd2fb50",
        "storage_key": "property/6737460151191764/019e1e3c-aa2e-729b-a8c6-35ba4dd2fb50.webp",
        "width": 827,
        "height": 1240
      },
      "poi_business_url": "http://www.chsgeorgia.org/SCM",
      "poi_directions_map_url": "https://maps.google.com/?cid=606148658374513045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-childrens-museum",
      "poi_latitude": "32.0760234",
      "poi_longitude": "-81.10093359999999",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-651-6823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb",
        "storage_key": "property/6737460151191764/019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RuwSlue-4gRlRF-R_54aQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_db0e75f1-8c92-4b94-ac28-43b546242d66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Memorial Health University Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4700 Waters Ave, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-6fde-737f-b323-424dc5552186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-6fde-737f-b323-424dc5552186",
        "storage_key": "property/6737460151191764/019e1e3a-6fde-737f-b323-424dc5552186.webp",
        "width": 564,
        "height": 317
      },
      "poi_business_url": "https://www.memorialhealth.com/locations/memorial-health-university-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4320841453139011030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-health-university-medical-center",
      "poi_latitude": "32.0303424",
      "poi_longitude": "-81.089434",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-350-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8b00-76b9-a403-681f9e33cf51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8b00-76b9-a403-681f9e33cf51",
        "storage_key": "property/6737460151191764/019e1e3a-8b00-76b9-a403-681f9e33cf51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58O7Xe51-4gR1iUiqWi29js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_39bb6b62-0a00-4013-b68e-32d8572ec959",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "SATS - Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1444 Dean Forest Rd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-aeda-74a8-8720-a837b623058e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-aeda-74a8-8720-a837b623058e",
        "storage_key": "property/6737460151191764/019e1e3c-aeda-74a8-8720-a837b623058e.webp",
        "width": 946,
        "height": 630
      },
      "poi_business_url": "http://www.satsurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4821468604731685678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sats---urgent-care",
      "poi_latitude": "32.0647389",
      "poi_longitude": "-81.20408979999999",
      "poi_miles_from_property": "15.7",
      "poi_walking_minutes": "5 hours 46 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-964-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc53ca2Kg-4gRLvu6mCZM6UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_bf0b90cb-00aa-4628-9610-c74f4ff6f92e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Pooler Parkway",
      "poi_type": "Health and Wellness",
      "poi_address": "105 Grand Central Blvd STE 108, Pooler, GA 31322, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b010-778c-8af4-6695dca77803.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b010-778c-8af4-6695dca77803",
        "storage_key": "property/6737460151191764/019e1e3c-b010-778c-8af4-6695dca77803.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.carenow.com/locations/savannah/pooler-parkway?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12160595711574483382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---pooler-parkway",
      "poi_latitude": "32.134112",
      "poi_longitude": "-81.25593769999999",
      "poi_miles_from_property": "23.6",
      "poi_walking_minutes": "8 hours 40 mins",
      "poi_biking_minutes": "2 hours 4 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 912-748-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZNyzGye-4gRtiGJvV4dw6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_77eb31ae-9bea-413f-aaba-9541547647f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12012 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-9773-771e-bcff-34d047369ddc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-9773-771e-bcff-34d047369ddc",
        "storage_key": "property/6737460151191764/019e1e3c-9773-771e-bcff-34d047369ddc.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/savannah-ga-pharmacies/12012-abercorn-street-savannah-ga-31419/storeid=4229?WT.mc_id=LS_GOOGLE_RX_4229",
      "poi_directions_map_url": "https://maps.google.com/?cid=13421052061662591112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "31.9822976",
      "poi_longitude": "-81.15340200000001",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-925-5568",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e058-76f9-867d-d20e64b8d780.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e058-76f9-867d-d20e64b8d780",
        "storage_key": "property/6737460151191764/019e1e3c-e058-76f9-867d-d20e64b8d780.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2BSiMh0-4gRiDhsB74nQbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a2bbae80-4ded-4d1e-9d77-3d1005e3513d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11509 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b199-700e-ac09-f69f8c1250ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b199-700e-ac09-f69f8c1250ba",
        "storage_key": "property/6737460151191764/019e1e3c-b199-700e-ac09-f69f8c1250ba.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11509+abercorn+st-savannah-ga-31419/id=5368",
      "poi_directions_map_url": "https://maps.google.com/?cid=1181130347606482074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "31.9810657",
      "poi_longitude": "-81.1492461",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-927-6119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e058-76f9-867d-d20e64b8d780.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e058-76f9-867d-d20e64b8d780",
        "storage_key": "property/6737460151191764/019e1e3c-e058-76f9-867d-d20e64b8d780.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ15QGBcd0-4gRmpyEEss3ZBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_0861861a-8d16-44e6-b76c-195d09410333",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Publix Pharmacy at Largo Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "11701 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b06b-755b-b29c-5a9ca9c29a82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b06b-755b-b29c-5a9ca9c29a82",
        "storage_key": "property/6737460151191764/019e1e3c-b06b-755b-b29c-5a9ca9c29a82.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=3815379787607602945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-largo-plaza",
      "poi_latitude": "31.9813756",
      "poi_longitude": "-81.1521246",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-925-4117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e058-76f9-867d-d20e64b8d780.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e058-76f9-867d-d20e64b8d780",
        "storage_key": "property/6737460151191764/019e1e3c-e058-76f9-867d-d20e64b8d780.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_ET8Bx1-4gRAXeOu7Pz8jQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a4de9f7e-6c31-4860-ac5a-24331e43d5ed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "14030 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-afb9-777a-bf22-6e6542d67d84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-afb9-777a-bf22-6e6542d67d84",
        "storage_key": "property/6737460151191764/019e1e3c-afb9-777a-bf22-6e6542d67d84.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/4556-savannah-ga/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=387970644702086086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "31.9808092",
      "poi_longitude": "-81.17354399999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 912-344-9671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e058-76f9-867d-d20e64b8d780.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e058-76f9-867d-d20e64b8d780",
        "storage_key": "property/6737460151191764/019e1e3c-e058-76f9-867d-d20e64b8d780.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7Zt5DcL-4gRxkO_7D5ZYgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1f731dff-75c7-44c1-bd4f-e20794b049a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Hickman Boxing at Champions Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10010 Abercorn St #5a, Savannah, GA 31406, USA",
      "poi_short_description": "Boxing gym offering introductory and advanced training in a kid-friendly environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b382-7330-8181-2b40498fafb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b382-7330-8181-2b40498fafb1",
        "storage_key": "property/6737460151191764/019e1e3c-b382-7330-8181-2b40498fafb1.webp",
        "width": 828,
        "height": 466
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3698843201531972030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hickman-boxing-at-champions-training-center",
      "poi_latitude": "31.9904308",
      "poi_longitude": "-81.1289259",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-507-4597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlU2CWZx1-4gRvokuY0vuVDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_coaching"
    },
    {
      "id": "custom_2383a98b-c196-4dc6-8b1d-526e16331ff6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3609 Ogeechee Rd, Savannah, GA 31405, USA",
      "poi_short_description": "Chain gym with a wide range of equipment, including massage chairs, and tanning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-6180-731c-9afd-e5e2d086108b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-6180-731c-9afd-e5e2d086108b",
        "storage_key": "property/6737460151191764/019e1e3a-6180-731c-9afd-e5e2d086108b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/savannah-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2869411139373950372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.0506622",
      "poi_longitude": "-81.1442641",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-231-3733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwuB1uCf-4gRpOXufDoy0ic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_657f6435-3bae-43b6-99c4-91b336beeb42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "5521 Abercorn St Suite 500, Savannah, GA 31406, USA",
      "poi_short_description": "Ballet-inspired fitness center focusing on low-impact, high-intensity exercises for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b2b1-75ff-aba8-1fd7672829b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b2b1-75ff-aba8-1fd7672829b2",
        "storage_key": "property/6737460151191764/019e1e3c-b2b1-75ff-aba8-1fd7672829b2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/savannah-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=2331048834905319645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "32.0248728",
      "poi_longitude": "-81.1103564",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-665-1129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-GpxZl1-4gR3aienpCMWSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_ecc62b83-9669-4250-a449-77018a3da044",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Mohawk Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1134 Mohawk St, Savannah, GA 31419, USA",
      "poi_short_description": "Community park for big and small pups featuring grassy areas and a lake amid scenic surrounds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b3bd-73cc-9bf2-d3ab0b30f41f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b3bd-73cc-9bf2-d3ab0b30f41f",
        "storage_key": "property/6737460151191764/019e1e3c-b3bd-73cc-9bf2-d3ab0b30f41f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10578989518803625640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mohawk-dog-park",
      "poi_latitude": "31.99274239999999",
      "poi_longitude": "-81.1687963",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_dJNLTwL-4gRqObe3uoe0JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_48b2d497-fd26-4983-b822-ae693bdc5ab3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Joseph Tribble Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12517 Largo Dr, Savannah, GA 31419, USA",
      "poi_short_description": "Peaceful, dog-friendly park featuring a playground, picnic area, pond and trails for jogging and walking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b838-72e3-984d-d24e9c714794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b838-72e3-984d-d24e9c714794",
        "storage_key": "property/6737460151191764/019e1e3c-b838-72e3-984d-d24e9c714794.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahga.gov/index.aspx?NID=351",
      "poi_directions_map_url": "https://maps.google.com/?cid=12182625584448583248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joseph-tribble-park",
      "poi_latitude": "31.96891249999999",
      "poi_longitude": "-81.15563809999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-351-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTmwDLB0-4gRULakOGxhEak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_771f3da4-ef21-445c-b90a-fe1a38d54bd1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Windsor Neighborhood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12412 Woodley Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Park offering play areas for kids and a playground, plus fenced-in dog areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b8b0-77ed-ad3d-e73d1cf91631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b8b0-77ed-ad3d-e73d1cf91631",
        "storage_key": "property/6737460151191764/019e1e3c-b8b0-77ed-ad3d-e73d1cf91631.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7748477786242411251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windsor-neighborhood-park",
      "poi_latitude": "31.974602",
      "poi_longitude": "-81.13819699999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI3kJlah1-4gR8-r7Tn4fiGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3ab1e02c-6c14-4aeb-a0b8-832c23da3c4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "L Scott Stell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "195 Scott Stell Park, Savannah, GA 31419, USA",
      "poi_short_description": "Easygoing, lakefront space with a boat launch, walking trails & covered picnic facilities.",
      "poi_long_description": "Easygoing, lakefront space with a boat launch, walking trails & covered picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b7d9-7379-90b0-df21aabed9b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b7d9-7379-90b0-df21aabed9b2",
        "storage_key": "property/6737460151191764/019e1e3c-b7d9-7379-90b0-df21aabed9b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=568174053801707977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "l-scott-stell-park",
      "poi_latitude": "32.0386394",
      "poi_longitude": "-81.2854385",
      "poi_miles_from_property": "13.2",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-436-6531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UIqNzMI-4gRyclxp0qP4gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a876a8f1-1f86-4b8a-ba35-02045ced50f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Lake Mayer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1850 E Montgomery Cross Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Park with a lake offering picnic areas, a playground, tennis courts, and a skateboarding area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-7837-70cd-9823-e82683b1cf58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-7837-70cd-9823-e82683b1cf58",
        "storage_key": "property/6737460151191764/019e1e3a-7837-70cd-9823-e82683b1cf58.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/CommunityParks/LakeMayer",
      "poi_directions_map_url": "https://maps.google.com/?cid=1999149330770112106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-mayer-park",
      "poi_latitude": "31.992331",
      "poi_longitude": "-81.08626799999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-652-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQSN4wkl1-4gRai6Dcblnvhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_567fb344-8802-42af-8c0a-eedcc50d2277",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Savannah Ogeechee Canal Museum and Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "681 Fort Argyle Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Museum charting the history of an 1880s commercial canal, with models & remains of its locks.",
      "poi_long_description": "Museum charting the history of an 1880s commercial canal, with models & remains of its locks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-b902-762f-a056-34e818bc41d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-b902-762f-a056-34e818bc41d5",
        "storage_key": "property/6737460151191764/019e1e3c-b902-762f-a056-34e818bc41d5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahogeecheecanal.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3306472962369169396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-ogeechee-canal-museum-and-nature-center",
      "poi_latitude": "32.0231191",
      "poi_longitude": "-81.3167919",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-748-8068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb",
        "storage_key": "property/6737460151191764/019e1e3a-8ae4-73b8-9310-47bc2c7ebbfb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXT4FV0I-4gR9KdyDaTz4i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9392e25d-da44-4078-b96a-6bfb4ea7914e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Al Bungard Conservation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Chief Of Love Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Park on a small lake featuring picnic tables and a pavilion.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-bf5e-73fa-9a90-49aba5431a0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-bf5e-73fa-9a90-49aba5431a0e",
        "storage_key": "property/6737460151191764/019e1e3c-bf5e-73fa-9a90-49aba5431a0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/NaturePreserves/BungardConservationArea",
      "poi_directions_map_url": "https://maps.google.com/?cid=4893777153824965471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "al-bungard-conservation-area",
      "poi_latitude": "31.9871373",
      "poi_longitude": "-81.286228",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVILpBoJ-4gRX8Oon2Qw6kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_b079026c-960f-4f22-bc69-3fbf9a93ea74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Kings Ferry",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6820 Chief Of Love Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Tranquil park along the Ogeechee River, with a boat ramp and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-be15-70da-a8f5-6d6bc5b74099.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-be15-70da-a8f5-6d6bc5b74099",
        "storage_key": "property/6737460151191764/019e1e3c-be15-70da-a8f5-6d6bc5b74099.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://parks.chathamcounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4262276922834071583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-ferry",
      "poi_latitude": "31.9785709",
      "poi_longitude": "-81.28783419999999",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-652-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ab0-70b9-82bd-97e8fa209d4a",
        "storage_key": "property/6737460151191764/019e1e3a-8ab0-70b9-82bd-97e8fa209d4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPaj9DCUJ-4gRH7DeX0emJjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a0635f1f-30cc-4219-9a5d-b230e6ee4514",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Middleground & Mohawk SB",
      "poi_type": "Transportation & Transit",
      "poi_address": "Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6702626698457472112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middleground--mohawk-sb",
      "poi_latitude": "31.986188",
      "poi_longitude": "-81.16032799999999",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDd9vZcx0-4gRcFybX3iDBF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_8b16e4d9-c2ba-47da-9245-827f5adce914",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Joe Murray Rivers, Jr. Intermodal Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-c010-752a-9589-c8cf094dafe8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-c010-752a-9589-c8cf094dafe8",
        "storage_key": "property/6737460151191764/019e1e3c-c010-752a-9589-c8cf094dafe8.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "http://www.catchacat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901387300494243883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joe-murray-rivers-jr-intermodal-transit-center",
      "poi_latitude": "32.0795155",
      "poi_longitude": "-81.0998743",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e057-7322-b5b6-d495c574d344.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e057-7322-b5b6-d495c574d344",
        "storage_key": "property/6737460151191764/019e1e3c-e057-7322-b5b6-d495c574d344.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6fx-Fye-4gRK_i97uJdp20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_8f7093b9-5b77-4a17-9e6b-357e27b6fcb3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Savannah",
      "poi_type": "Transportation & Transit",
      "poi_address": "2611 Seaboard Coastline Dr, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-c019-728f-91af-bd661acceb08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-c019-728f-91af-bd661acceb08",
        "storage_key": "property/6737460151191764/019e1e3c-c019-728f-91af-bd661acceb08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=SAV",
      "poi_directions_map_url": "https://maps.google.com/?cid=1136550232795717085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah",
      "poi_latitude": "32.083701",
      "poi_longitude": "-81.1485479",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-e07f-708f-97e4-864b1576cbd1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3c-e07f-708f-97e4-864b1576cbd1",
        "storage_key": "property/6737460151191764/019e1e3c-e07f-708f-97e4-864b1576cbd1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbNe15mf-4gR3R0tP2rWxQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_b757af4c-a5be-45a2-8461-a8b273789d5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Hunter Army Airfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "Horace Emmet, 685 Wilson Boulevard, Savannah, GA 31409, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-c4ac-719b-a9d2-79262c6e40fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-c4ac-719b-a9d2-79262c6e40fa",
        "storage_key": "property/6737460151191764/019e1e3c-c4ac-719b-a9d2-79262c6e40fa.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://home.army.mil/stewart/about/Garrison/hunter-army-airfield",
      "poi_directions_map_url": "https://maps.google.com/?cid=10321136575425091550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hunter-army-airfield",
      "poi_latitude": "32.0110535",
      "poi_longitude": "-81.1470286",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8d3a-746b-8a0c-17daf996e6c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8d3a-746b-8a0c-17daf996e6c1",
        "storage_key": "property/6737460151191764/019e1e3a-8d3a-746b-8a0c-17daf996e6c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQOCoi51-4gR3heBGAgLPI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_7ca9ea6f-a46d-4695-a06c-b9c22ea15d9d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Gulfstream Aerospace Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Gulfstream Rd, Savannah, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-c3a7-73d5-a6dc-9a7cc7a9c075.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-c3a7-73d5-a6dc-9a7cc7a9c075",
        "storage_key": "property/6737460151191764/019e1e3c-c3a7-73d5-a6dc-9a7cc7a9c075.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.gulfstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14719559404661686851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulfstream-aerospace-corporation",
      "poi_latitude": "32.1392172",
      "poi_longitude": "-81.1973454",
      "poi_miles_from_property": "18.5",
      "poi_walking_minutes": "6 hours 48 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 912-965-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeWtFyii-4gRQ8IefUphRsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_50ddf21d-eb97-4f38-93b5-794e99f66d1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Savannah/Hilton Head International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 Airways Ave, Savannah, GA 31408, USA",
      "poi_short_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_long_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-d696-71fe-943a-d5593c72b593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-d696-71fe-943a-d5593c72b593",
        "storage_key": "property/6737460151191764/019e1e3c-d696-71fe-943a-d5593c72b593.webp",
        "width": 1280,
        "height": 556
      },
      "poi_business_url": "https://savannahairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3301384233227292702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannahhilton-head-international-airport",
      "poi_latitude": "32.1294229",
      "poi_longitude": "-81.201871",
      "poi_miles_from_property": "18.2",
      "poi_walking_minutes": "6 hours 41 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 912-964-0514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8d28-709b-89b7-98dcbc6981a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8d28-709b-89b7-98dcbc6981a0",
        "storage_key": "property/6737460151191764/019e1e3a-8d28-709b-89b7-98dcbc6981a0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRNnApyh-4gRHpCW-Hff0C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_32b468e2-2983-4f60-b585-6e7fca6fd2e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Georgia Ports Authority - Administrative Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2 Main St, Garden City, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-c51a-77cb-b202-37f6ee849137.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-c51a-77cb-b202-37f6ee849137",
        "storage_key": "property/6737460151191764/019e1e3c-c51a-77cb-b202-37f6ee849137.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gaports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3663778410647710348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-ports-authority---administrative-building",
      "poi_latitude": "32.1286475",
      "poi_longitude": "-81.15145869999999",
      "poi_miles_from_property": "14.3",
      "poi_walking_minutes": "5 hours 20 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-964-3811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aaf-768d-8462-4590fef4dc12",
        "storage_key": "property/6737460151191764/019e1e3a-8aaf-768d-8462-4590fef4dc12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf78Ok-f-4gRjOpmjg1b2DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fff5a1b8-4974-4256-952a-b80929e13354",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "St. Joseph's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11705 Mercy Boulevard, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-c90d-760a-8f02-fa6189d6296d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-c90d-760a-8f02-fa6189d6296d",
        "storage_key": "property/6737460151191764/019e1e3c-c90d-760a-8f02-fa6189d6296d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sjchs.org/locations/locationdetails/st-josephs-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=17180114475573257524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-josephs-hospital",
      "poi_latitude": "31.9853909",
      "poi_longitude": "-81.1553605",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 912-819-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8b00-76b9-a403-681f9e33cf51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8b00-76b9-a403-681f9e33cf51",
        "storage_key": "property/6737460151191764/019e1e3a-8b00-76b9-a403-681f9e33cf51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDaHTOhae-4gRNCUXZRcHbO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0d0edd55-7826-42e3-8742-e2e150dd0815",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Candler Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5353 Reynolds St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-71ce-77d1-8e7c-f83a1843cac0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-71ce-77d1-8e7c-f83a1843cac0",
        "storage_key": "property/6737460151191764/019e1e3a-71ce-77d1-8e7c-f83a1843cac0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sjchs.org/locations/locationdetails/candler-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12058112974386619187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "candler-hospital",
      "poi_latitude": "32.0281014",
      "poi_longitude": "-81.1003141",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-819-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8b00-76b9-a403-681f9e33cf51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8b00-76b9-a403-681f9e33cf51",
        "storage_key": "property/6737460151191764/019e1e3a-8b00-76b9-a403-681f9e33cf51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpb2fD5N1-4gRM-PXE90FV6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f1253455-3689-4cc6-a6b7-f1941b93064e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Savannah State University",
      "poi_type": "Education",
      "poi_address": "3219 College St, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3c-c9f1-76fc-a670-f50c192abea3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3c-c9f1-76fc-a670-f50c192abea3",
        "storage_key": "property/6737460151191764/019e1e3c-c9f1-76fc-a670-f50c192abea3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://savannahstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=170532476337488424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-state-university",
      "poi_latitude": "32.0241968",
      "poi_longitude": "-81.0625787",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "187",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-358-4162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp5BqurZ3-4gRKILDOmLaXQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a06c6b89-be4f-4f21-b96f-0d939d4dcab7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "1040 King George Blvd, Savannah, GA 31419, USA",
      "poi_short_description": "Grocery chain featuring groceries, as well as a deli, bakery and wine selection.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-3a62-734d-bd71-e966554c7788.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-3a62-734d-bd71-e966554c7788",
        "storage_key": "property/6737460151191764/019ea90d-3a62-734d-bd71-e966554c7788.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.foodlion.com/ga/savannah/1040-king-george-blvd?y_source=1_NTA0NzA0MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8638998985582223384&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "31.9862933",
      "poi_longitude": "-81.2205559",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-920-2114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-c924fb04edaf",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-c924fb04edaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6e8JQ70L-4gRGKCWVs7j43c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_28c6bef4-7245-4705-89cb-aae0319c48d5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "14045 Abercorn St #1503, Savannah, GA 31419, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "This outdoor store is praised by visitors for its extensive selection of fishing, camping, hunting, and boating gear, alongside a delightful aquarium that appeals to children. Reviewers also consistently mention the friendly and knowledgeable staff, as well as the store's clean and organized environment.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-36ba-751a-9700-b13fe4824d01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-36ba-751a-9700-b13fe4824d01",
        "storage_key": "property/6737460151191764/019ea90d-36ba-751a-9700-b13fe4824d01.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://stores.basspro.com/us/ga/savannah/14045-abercorn-st.html?y_source=1_MzAxMTUxOS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3361603795993073834&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "31.9834837",
      "poi_longitude": "-81.1725417",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-961-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvfqHjDcL-4gRqpjFh9fQpi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_3ba72edb-84b6-4d6a-b99a-eac4ce7ef52a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "DICK'S Sporting Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "318 Mall Blvd Ste #200, Savannah, GA 31406, USA",
      "poi_short_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_long_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-36c7-749b-9996-ae0f42b9553e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-36c7-749b-9996-ae0f42b9553e",
        "storage_key": "property/6737460151191764/019ea90d-36c7-749b-9996-ae0f42b9553e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.dickssportinggoods.com/ga/savannah/1106/?seo=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=3349353766397666147&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dicks-sporting-goods",
      "poi_latitude": "32.0060982",
      "poi_longitude": "-81.1114071",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-480-9037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ6_yj651-4gRY-M_QYFLey4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_caad0ef2-7c30-44df-86da-d5ebbda06449",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Dunkin' Donuts",
      "poi_type": "Restaurants",
      "poi_address": "5921 Ogeechee Rd Savannh GA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e8c32abf-e715-4614-a8db-f83e783e60a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "8108 Abercorn Savannh GA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db30d86e-41b2-4916-9345-cb13819fa006",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "14065 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Customers consistently praise this store for being clean and well-maintained, offering great prices, and having friendly staff who provide quick service.\n\nOther reviews mention the return policy can be inconsistent and staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-36ca-740b-b5f7-6fcff1877427.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-36ca-740b-b5f7-6fcff1877427",
        "storage_key": "property/6737460151191764/019ea90d-36ca-740b-b5f7-6fcff1877427.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/savannah/1910",
      "poi_directions_map_url": "https://maps.google.com/?cid=1239185135758866222&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "31.98414069999999",
      "poi_longitude": "-81.1746917",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-925-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7VON0DkL-4gRLvfZw1B4MhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_fb7e2a7c-262a-4e18-a765-6c4c26e85ecc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "5401 Abercorn St Savannh GA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_654bdfa7-44d2-4632-afc6-4be0162f784b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "7825 Abercorn St, Savannah, GA 31406, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Reviewers consistently praise this steakhouse for its delicious and well-cooked steaks, along with generous portion sizes and friendly staff.\n\nOther reviews mention the service can be inattentive and slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-3b2a-76c8-81b3-51f89fb44d42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-3b2a-76c8-81b3-51f89fb44d42",
        "storage_key": "property/6737460151191764/019ea90d-3b2a-76c8-81b3-51f89fb44d42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ga/savannah/savannah/5028?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:savannah-ga-5028_pl:locurl_rd:1015",
      "poi_directions_map_url": "https://maps.google.com/?cid=7650018870509401593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "32.004516",
      "poi_longitude": "-81.119569",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-352-4784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwL7Gqp1-4gR-XW_laFTKmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_6d84b954-0a0f-4be4-9a00-2630e0fef359",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "23 W Montgomery Cross Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious food, particularly the steaks and the generous portions, including the delectable rolls with honey cinnamon butter, and appreciate that the food arrives hot. The clean and lively atmosphere is also frequently mentioned, along with the friendly staff and the convenience of their waitlist system.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-53ba-73fc-a2c9-80a128639edb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e3a-53ba-73fc-a2c9-80a128639edb",
        "storage_key": "property/6737460151191764/019e1e3a-53ba-73fc-a2c9-80a128639edb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/georgia/savannah?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=16512463902751734832&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.9982185",
      "poi_longitude": "-81.1240833",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-961-5650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfqHjDcL-4gRMDz6yW4OKOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_8ea77f51-ab1f-476d-b1a9-312e96939ed6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "7805 Abercorn St Ste 26, Savannah, GA 31406, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Reviewers consistently praise this restaurant for its delicious burgers, country fried steak, and baby back ribs, and appreciate the friendly staff.\n\nOther reviews mention the service can be inattentive and slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-3a9d-765c-89ea-482381999232.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-3a9d-765c-89ea-482381999232",
        "storage_key": "property/6737460151191764/019ea90d-3a9d-765c-89ea-482381999232.webp",
        "width": 1280,
        "height": 869
      },
      "poi_business_url": "https://www.chilis.com/locations/us/georgia/savannah/savannah?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=2982950906464086005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "32.005359",
      "poi_longitude": "-81.117954",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-352-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_jfG6p1-4gR9ac4iguSZSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_11c1fd7c-a106-47dd-9fc3-e2d11d77bcbe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Jalapeños | Authentic Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "8840 Abercorn St #5, Savannah, GA 31406, USA",
      "poi_short_description": "Casual restaurant dishing up traditional & fusion dishes along with margarita cocktails.",
      "poi_long_description": "People say this Mexican restaurant serves delicious steak tacos, fajita quesadillas, and guacamole dip. They also highlight the generous portions, fresh ingredients, and bold, authentic flavors.\n\nOther reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-3c53-749a-accf-8fff1855cb08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-3c53-749a-accf-8fff1855cb08",
        "storage_key": "property/6737460151191764/019ea90d-3c53-749a-accf-8fff1855cb08.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.jalapenosinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660531417219136685&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jalapeos--authentic-mexican-grill",
      "poi_latitude": "31.9966102",
      "poi_longitude": "-81.1278409",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-920-0704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8aae-758f-8e6a-4b187bf3f867",
        "storage_key": "property/6737460151191764/019e1e3a-8aae-758f-8e6a-4b187bf3f867.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5qCAP10-4gRrfw8kNfQ8ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b3e68517-a39c-4f29-9744-d579a8e77e40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Dillard's",
      "poi_type": "Shopping & Retail",
      "poi_address": "14025 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_long_description": "Visitors say this department store offers a great selection of merchandise, including shoes, dresses, and fragrances, with many unique items. They also highlight the friendly, helpful, and knowledgeable staff.\n\nSome reviews mention returns can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-36b6-7599-8f4c-529c596d5d4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-36b6-7599-8f4c-529c596d5d4b",
        "storage_key": "property/6737460151191764/019ea90d-36b6-7599-8f4c-529c596d5d4b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/stores/georgia/savannah-mall-savannah/0277",
      "poi_directions_map_url": "https://maps.google.com/?cid=13580615827542191825&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dillards",
      "poi_latitude": "31.9833802",
      "poi_longitude": "-81.17045859999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-920-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVVVVYUL-4gR0S6zVyQKeLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_af0f0b9e-0972-40b2-aa68-588acdda6a66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Oglethorpe Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7804 Abercorn Extention, Savannah, GA 31406, USA",
      "poi_short_description": "Big shopping mall featuring department stores, name-brand retailers, a food court & restaurants.",
      "poi_long_description": "Visitors say this indoor mall offers a wide variety of stores, including major anchor stores, and features a good food court with plenty of seating. They also highlight the clean environment, ample parking, and the presence of EV charging stations.\n\nSome reviews mention the mall can be run-down.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-36ca-740b-b5f7-72aaafeb3e65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-36ca-740b-b5f7-72aaafeb3e65",
        "storage_key": "property/6737460151191764/019ea90d-36ca-740b-b5f7-72aaafeb3e65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.oglethorpemall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8202028011205318403&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oglethorpe-mall",
      "poi_latitude": "32.0027718",
      "poi_longitude": "-81.11702799999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-629-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHafA_6p1-4gRA1eyHQV103E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_bb191b14-c8f9-45b5-acf2-9125a6d1bada",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "11140 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "Shoppers say this craft store offers a wide variety of craft supplies, décor, and sewing materials at reasonable prices. They also highlight the clean and well-organized environment, with clear signage to help customers find what they need.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-3d74-73cc-968a-1819d244c035.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-3d74-73cc-968a-1819d244c035",
        "storage_key": "property/6737460151191764/019ea90d-3d74-73cc-968a-1819d244c035.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/612",
      "poi_directions_map_url": "https://maps.google.com/?cid=17808700126290818959&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "31.9824161",
      "poi_longitude": "-81.1430664",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-920-5759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5UQDucF0-4gRj7cEC2k2Jfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_805b8f59-7f08-4737-ad86-98a05d1e866e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "8108 Abercorn St, Shopping Center, Abercorn Plaza #400, Savannah, GA 31406, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "People say this craft store offers a wide variety of supplies, including glow-in-the-dark spray paint, for projects like building lighthouses. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019ea90d-3e40-70a3-a30c-9bd9d06cd151.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea90d-3e40-70a3-a30c-9bd9d06cd151",
        "storage_key": "property/6737460151191764/019ea90d-3e40-70a3-a30c-9bd9d06cd151.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.michaels.com/GA/Savannah/5815/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=18281973383852814581&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "32.0018086",
      "poi_longitude": "-81.1238685",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-927-3806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8acb-7788-82c4-cc8ee092535d",
        "storage_key": "property/6737460151191764/019e1e3a-8acb-7788-82c4-cc8ee092535d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSZ9LGwF1-4gR9XCxOe6dtv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_c68e3213-99ee-4ad7-a51e-8ba6676ac236",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "custom",
      "poi_name": "White Bluff Elementary School",
      "poi_type": "Education",
      "poi_address": "9402 White Bluff Rd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5818570617262239194&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "white-bluff-elementary-school",
      "poi_latitude": "31.990673",
      "poi_longitude": "-81.1271362",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 912-395-3325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-8ad5-75e8-9095-c88dee70c53b",
        "storage_key": "property/6737460151191764/019e1e3a-8ad5-75e8-9095-c88dee70c53b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNUYzNvp0-4gR2u1w9iW3v1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    }
  ],
  "office_hours": [
    {
      "id": "custom_acf98412-180d-4932-b38b-4546ca7b8f81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d80994de-2558-4173-bd37-0962af862023",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e93bb985-5439-4f3e-b8b0-1d553bad5f9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_085f151d-b786-4b42-bd42-ac6ed327cab6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7a6071a5-738d-43bb-94da-6d87ffb47e5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3c4ccfe1-7873-4c5f-aa3b-f78fd574aa60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_953024f0-21fc-4fd4-8d2a-5902c902b9de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "rating": "4",
      "name": "derrick mcdaniel",
      "text": "Ms.Terri is a great cool manger out here she’s mean but cool if that makes any sense but also have a great sense of humor",
      "date": "2026-02-06",
      "title": "false"
    },
    {
      "id": "custom_34109a5e-8896-40d1-9076-5f697ed85e34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "rating": "5",
      "name": "Kimberlie Norbrun",
      "text": "I came in with a friend who was looking for an apartment. Terri was so thorough and pleasant explained everything. I did an application as well. She welcomed us with a smile and was very professional and helped me through the process with patience. Thank you Terri, I can’t wait to move in!",
      "date": "2026-02-06",
      "title": "false"
    },
    {
      "id": "custom_05d73ca0-46b3-4cd8-9c03-8420d6bd67e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "rating": "5",
      "name": "José miguel Moreno medina",
      "text": "I have lived in this community for over a year. Terry helped me moving into my new apartment, everything went well and I love my apartment. I am now down sizing and I will stay here at Ridgewood I love it! I have no issue getting anywhere. Everything even shopping is close even the bus I had to catch it when my daughter was at work. If you are looking for a great place to live I recommend you come see Terry!",
      "date": "2025-12-19",
      "title": "false"
    },
    {
      "id": "custom_c902e083-ee86-451a-9b6a-12aa32cb5110",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "rating": "5",
      "name": "Dominique Isabella",
      "text": "Great place to live. The property managers are very helpful. They make moving in very simple and convenient. Terri who works in the main office is always accommodating to our needs in the apartment. Thank you so much to this team, they are great!",
      "date": "2025-10-24",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_95d9bc1ef45192dfac1a19c0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019de22c-c333-736b-b72f-346afff776bd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019de22c-c333-736b-b72f-346afff776bd",
        "storage_key": "property/6737460151191764/019de22c-c333-736b-b72f-346afff776bd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QVF8wEBhgAR"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fb5-493b-70db-a0a9-d48f2b2708d1",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-ridgewood-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764"
    },
    {
      "lead_collector_id": "019a5026-a301-76ed-bae4-dbf329594841",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-ridgewood-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "generator",
      "page_item_url": "ridgewood-apartments-with-pool-savannah-ga",
      "search_query": "apartments with pool in Savannah GA",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Savannah, GA",
      "h2_subtitle": "Discover apartments with a refreshing pool located in Savannah, GA. Enjoy serene poolside relaxation just steps from your Ridgewood apartment home.",
      "page_copy": "Ridgewood provides you with not only a comfortable living space but also the luxury of having access to one of the best pools in Savannah, GA. Whether you're seeking a peaceful day under the sun or invigorating exercise in the water, our pool offers the perfect retreat from the everyday hustle. Positioned in the lively Wilshire Estates-Savannah Mall neighborhood, it's an ideal spot to unwind after a busy day.\n\nOur community is more than just apartments with a pool; it's an experience designed for modern living. Dive in, and then make use of our exceptional amenities, like the fitness center or sundeck, perfect for soaking in the vibrant Georgia sun. At Ridgewood, our one, two, and three-bedroom apartments are waiting for you—come and schedule a tour to see how our pool can become part of your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front.",
        "public_id": "019d076e-3ef1-7753-b5ff-82b0d039a4f9",
        "storage_key": "property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
        "width": 1240,
        "height": 789
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Savannah, GA | Ridgewood",
      "seo_description": "Discover Ridgewood's apartments with a pool in Savannah, GA. Enjoy amenities like a fitness center and sundeck. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "generator",
      "page_item_url": "ridgewood-savannah-ga-apartments-fitness-center",
      "search_query": "Savannah GA apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Savannah GA Apartments with Fitness Center",
      "h2_subtitle": "Experience Savannah, GA living in apartments featuring an advanced fitness center. Stay active just steps from your door at Ridgewood.",
      "page_copy": "Ridgewood offers premier Savannah, GA apartments with a state-of-the-art fitness center right on-site. Our inviting and modern facilities provide you the convenience of working out without leaving the community. Enjoy the flexibility of exercising at your own pace, with 24-hour access available to all residents. Alongside our fitness options, Ridgewood is nestled in the bustling Wilshire Estates-Savannah Mall neighborhood, merging style with practicality.\n\nIn addition to wellness amenities, Ridgewood provides a comprehensive living experience with spacious one, two, and three-bedroom floor plans. Relax after a workout at our sunlit pool or take advantage of our community facilities including cable readiness and ample storage space. Embrace the perfect blend of comfort and activity by scheduling a visit to Ridgewood today and discover the lifestyle waiting for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front.",
        "public_id": "019d076e-3ef1-7753-b5ff-82b0d039a4f9",
        "storage_key": "property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
        "width": 1240,
        "height": 789
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Savannah GA Apartments with Fitness Center | Ridgewood",
      "seo_description": "Live at Ridgewood in Savannah, GA with a fitness center on-site. Enjoy modern amenities and schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "generator",
      "page_item_url": "ridgewood-apartments-sundeck-chatham-county",
      "search_query": "Ridgewood apartments sundeck in Chatham County",
      "category": "Amenity",
      "h1_title": "Ridgewood Apartments Sundeck in Chatham",
      "h2_subtitle": "Relax at Ridgewood Apartments in Chatham County with a spacious sundeck. Enjoy the warm Savannah sun at our welcoming community.",
      "page_copy": "At Ridgewood Apartments, enjoy the perfect hangout spot with our expansive sundeck, designed to soak up the abundant Savannah sunshine. Nestled in Chatham County, our community offers residents a blend of relaxation and activity. Stretch out, relax, and let the warmth of the sun be a daily part of your Ridgewood routine.\n\nOur sundeck is only one of the many amenities we offer. Ridgewood boasts a pristine pool, modern fitness center, and thoughtfully designed one, two, and three-bedroom apartments. Positioned in the vibrant Wilshire Estates-Savannah Mall neighborhood, our community caters to those seeking both comfort and convenience. Explore the exceptional lifestyle and amenities Ridgewood offers by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front.",
        "public_id": "019d076e-3ef1-7753-b5ff-82b0d039a4f9",
        "storage_key": "property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
        "width": 1240,
        "height": 789
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ridgewood Apartments Sundeck in Chatham County",
      "seo_description": "Experience the sundeck at Ridgewood Apartments in Chatham County. Enjoy spacious living with modern amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "generator",
      "page_item_url": "ridgewood-apartments-in-unit-washer-dryer-savannah",
      "search_query": "apartments with in-unit washer and dryer Savannah",
      "category": "Amenity",
      "h1_title": "Savannah Apartments with In-Unit Washer & Dryer",
      "h2_subtitle": "Enjoy the convenience of apartments with an in-unit washer and dryer in Savannah, GA. Ridgewood brings comfort right into your home.",
      "page_copy": "Ridgewood offers the convenience you deserve with in-unit washer and dryer facilities in each of our spacious Savannah, GA apartments. Say goodbye to laundry day stress and enjoy the luxury of handling your clothes care at your leisure from the comfort of your own home. Located in the Wilshire Estates-Savannah Mall neighborhood, our community prioritizes resident ease and satisfaction.\n\nOur one, two, and three-bedroom apartments are designed with a focus on modern living, providing not just in-unit laundry but a wealth of amenities including a pool, fitness center, and sundeck. Ridgewood's exceptional location in Chatham County places you close to everything Savannah offers while providing a serene retreat. Schedule a tour today and see how our in-unit amenities can simplify and enhance your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front.",
        "public_id": "019d076e-3ef1-7753-b5ff-82b0d039a4f9",
        "storage_key": "property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
        "width": 1240,
        "height": 789
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Savannah Apartments with In-Unit Washer & Dryer",
      "seo_description": "Discover Ridgewood's Savannah apartments with an in-unit washer and dryer. Enjoy modern amenities and a prime location. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "generator",
      "page_item_url": "ridgewood-air-conditioned-apartments-near-wilshire-mall",
      "search_query": "air conditioned apartments near Wilshire Estates-Mall",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Wilshire Estates Mall",
      "h2_subtitle": "Stay cool in air conditioned apartments near Wilshire Estates-Savannah Mall. Ridgewood offers comfort all year round in Savannah, GA.",
      "page_copy": "Ridgewood provides comfort and convenience in Savannah, GA, with its air conditioned apartments located near the bustling Wilshire Estates-Savannah Mall. Our community is designed to offer a refreshing escape from the summer heat, ensuring you remain comfortable and cool in all seasons. Each of our one, two, and three-bedroom residences comes equipped with air conditioning to enhance your living experience.\n\nIn addition to climate comfort, Ridgewood boasts top-notch amenities like a pool, fitness center, and sundeck, making it a perfect choice for those seeking a vibrant lifestyle. Our Chatham County location offers easy access to local attractions while providing a relaxing community environment. Discover the Ridgewood difference by scheduling a visit and exploring our air conditioned homes today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front.",
        "public_id": "019d076e-3ef1-7753-b5ff-82b0d039a4f9",
        "storage_key": "property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
        "width": 1240,
        "height": 789
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Wilshire Estates Mall",
      "seo_description": "Ridgewood offers air conditioned apartments near Wilshire Estates-Savannah Mall. Stay cool and comfortable with modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "generator",
      "page_item_url": "ridgewood-1-bedroom-apartments-savannah-ga",
      "search_query": "1 bedroom apartments savannah ga",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Savannah, GA",
      "h2_subtitle": "Explore spacious 1 bedroom apartments in Savannah, GA at Ridgewood. Enjoy modern living with exceptional amenities right at your doorstep.",
      "page_copy": "Discover the perfect blend of comfort and style with our 1 bedroom apartments in Savannah, GA, at Ridgewood. These thoughtfully designed spaces are ideal for those seeking modern living with the added benefit of exceptional community amenities. Situated in the vibrant Wilshire Estates-Savannah Mall neighborhood, Ridgewood provides a serene retreat while placing you in the heart of all the city has to offer.\n\nOur community features not only cozy living spaces but also a range of amenities including a pool, fitness center, and sundeck for your enjoyment. Each apartment is move-in ready with conveniences like in-unit laundry facilities and air conditioning. Experience the welcoming atmosphere and vibrant community at Ridgewood by scheduling a tour to see our 1 bedroom apartments firsthand. Your perfect home awaits in Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front.",
        "public_id": "019d076e-3ef1-7753-b5ff-82b0d039a4f9",
        "storage_key": "property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
        "width": 1240,
        "height": 789
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Savannah, GA",
      "seo_description": "Find spacious 1 bedroom apartments at Ridgewood in Savannah, GA. Enjoy exceptional amenities and a prime location. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "generator",
      "page_item_url": "ridgewood-2-bedroom-apartments-chatham-county",
      "search_query": "2 bedroom apartments chatham county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Chatham County",
      "h2_subtitle": "Find spacious 2 bedroom apartments in Chatham County at Ridgewood. Enjoy exceptional living with modern amenities in Savannah, GA.",
      "page_copy": "Experience the best of Chatham County living with the 2 bedroom apartments at Ridgewood, where comfort meets modern design in Savannah, GA. Perfectly crafted for those who seek spacious and stylish accommodations, these apartments offer a blend of convenience and luxury. Located near Wilshire Estates-Savannah Mall, enjoy the ease of access to shopping, dining, and entertainment.\n\nRidgewood enhances your living experience with fantastic community features such as a refreshing pool, a well-equipped fitness center, and a relaxing sundeck. Every 2 bedroom apartment is designed with the resident in mind, providing ample space, in-unit laundry, and air conditioning for ultimate comfort. Embrace the vibrant community atmosphere and explore the charm of Savannah from a perfect home base. Schedule a tour today to discover why Ridgewood is the ideal choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front.",
        "public_id": "019d076e-3ef1-7753-b5ff-82b0d039a4f9",
        "storage_key": "property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
        "width": 1240,
        "height": 789
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Chatham County",
      "seo_description": "Discover spacious 2 bedroom apartments at Ridgewood in Chatham County. Enjoy modern amenities and vibrant living in Savannah, GA. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191764",
      "source": "generator",
      "page_item_url": "ridgewood-3-bedroom-apartments-near-wilshire-mall",
      "search_query": "3 bedroom apartments near wilshire estates savannah mall",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near Wilshire Estates Mall",
      "h2_subtitle": "Explore spacious 3 bedroom apartments near Wilshire Estates-Savannah Mall at Ridgewood. Enjoy ample space and modern amenities in Savannah, GA.",
      "page_copy": "Ridgewood invites you to discover our spacious 3 bedroom apartments near Wilshire Estates-Savannah Mall, where you can enjoy the perfect blend of comfort and convenience in Savannah, GA. These homes are ideal for families or roommates seeking ample living space with a location that keeps shopping, dining, and entertainment close at hand.\n\nOur community offers more than just a great location. Residents at Ridgewood enjoy top-of-the-line amenities, including a sparkling pool, a state-of-the-art fitness center, and a sun-soaked sundeck, all designed to enrich your lifestyle. Each 3 bedroom apartment features well-appointed interiors with air conditioning and in-unit laundry facilities, ensuring a hassle-free and comfortable stay. Visit us today to see why Ridgewood is a preferred choice for those searching for quality living near Wilshire Estates-Savannah Mall.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front.",
        "public_id": "019d076e-3ef1-7753-b5ff-82b0d039a4f9",
        "storage_key": "property/6737460151191764/019d076e-3ef1-7753-b5ff-82b0d039a4f9.webp",
        "width": 1240,
        "height": 789
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near Wilshire Estates Mall",
      "seo_description": "Discover spacious 3 bedroom apartments at Ridgewood near Wilshire Estates-Savannah Mall. Enjoy modern amenities and a prime location in Savannah, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3397"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483334"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4857250"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PL7WDM72"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_br_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=br"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "812-419-2827"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_br_title",
      "type": "STRING",
      "value": "Brochure/Flyer"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "812-943-2603"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "812-641-8482"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "812-203-5048"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "812-398-8075"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "812-505-5016"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_br_number",
      "type": "STRING",
      "value": "912-494-9469"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "812-733-0395"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "812-505-9744"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "812-646-9843"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "812-594-4450"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "812-415-2314"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "812-616-4793"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "812-366-9302"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "812-389-4583"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "812-286-4199"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "812-657-0049"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "812-616-4553"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_costar_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=costar"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "812-415-4717"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321172567"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "812-515-1212"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "812-554-5760"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "5824e160011ee506"
    },
    {
      "ID": "custom_knock_costar_title",
      "type": "STRING",
      "value": "CoStar"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "812-608-4844"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "812-458-3156"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_costar_number",
      "type": "STRING",
      "value": "912-599-3563"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "812-884-8345"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "812-419-2380"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "812-782-1947"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "812-998-5886"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "812-624-6892"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "http://www.ridgewoodsavannah.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191764/019e8492-e670-748a-b862-933928ae79f3.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "812-641-7177"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "812-594-4450"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3397",
  "custom_repli_id": "5028483334",
  "custom_realpage_id": "4857250",
  "custom_knock_a_link": "http://www.ridgewoodsavannah.com?utm_knock=a",
  "custom_knock_g_link": "http://www.ridgewoodsavannah.com?utm_knock=g",
  "custom_knock_r_link": "http://www.ridgewoodsavannah.com?utm_knock=r",
  "custom_knock_w_link": "http://www.ridgewoodsavannah.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-PL7WDM72",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "http://www.ridgewoodsavannah.com?utm_knock=al",
  "custom_knock_ar_link": "http://www.ridgewoodsavannah.com?utm_knock=ar",
  "custom_knock_br_link": "http://www.ridgewoodsavannah.com?utm_knock=br",
  "custom_knock_cl_link": "http://www.ridgewoodsavannah.com?utm_knock=cl",
  "custom_knock_fb_link": "http://www.ridgewoodsavannah.com?utm_knock=fb",
  "custom_knock_fl_link": "http://www.ridgewoodsavannah.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "http://www.ridgewoodsavannah.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "812-419-2827",
  "custom_knock_ads_link": "http://www.ridgewoodsavannah.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "http://www.ridgewoodsavannah.com?utm_knock=bnr",
  "custom_knock_br_title": "Brochure/Flyer",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "812-943-2603",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "http://www.ridgewoodsavannah.com?utm_knock=lcs",
  "custom_knock_lgp_link": "http://www.ridgewoodsavannah.com?utm_knock=lgp",
  "custom_knock_ppn_link": "http://www.ridgewoodsavannah.com?utm_knock=ppn",
  "custom_knock_psa_link": "http://www.ridgewoodsavannah.com?utm_knock=psa",
  "custom_knock_r_number": "812-641-8482",
  "custom_knock_w_number": "812-203-5048",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "812-398-8075",
  "custom_knock_amap_link": "http://www.ridgewoodsavannah.com?utm_knock=amap",
  "custom_knock_ar_number": "812-505-5016",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_br_number": "912-494-9469",
  "custom_knock_cl_number": "812-733-0395",
  "custom_knock_fb_number": "812-505-9744",
  "custom_knock_fl_number": "812-646-9843",
  "custom_knock_gp_number": "812-594-4450",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "http://www.ridgewoodsavannah.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "812-415-2314",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "http://www.ridgewoodsavannah.com?utm_knock=bcard",
  "custom_knock_bnr_number": "812-616-4793",
  "custom_knock_cfres_link": "http://www.ridgewoodsavannah.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "812-366-9302",
  "custom_knock_lgp_number": "812-389-4583",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "http://www.ridgewoodsavannah.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "812-286-4199",
  "custom_knock_psa_number": "812-657-0049",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "812-616-4553",
  "custom_knock_bandit_link": "http://www.ridgewoodsavannah.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_costar_link": "http://www.ridgewoodsavannah.com?utm_knock=costar",
  "custom_knock_flyers_link": "http://www.ridgewoodsavannah.com?utm_knock=flyers",
  "custom_knock_osoc_number": "812-415-4717",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321172567",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "812-515-1212",
  "custom_knock_cfres_number": "812-554-5760",
  "custom_knock_chatgpt_link": "http://www.ridgewoodsavannah.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "5824e160011ee506",
  "custom_knock_costar_title": "CoStar",
  "custom_knock_dirmail_link": "http://www.ridgewoodsavannah.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "812-608-4844",
  "custom_knock_propbro_link": "http://www.ridgewoodsavannah.com?utm_knock=propbro",
  "custom_knock_bandit_number": "812-458-3156",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_costar_number": "912-599-3563",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "812-884-8345",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "http://www.ridgewoodsavannah.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "812-419-2380",
  "custom_knock_dirmail_number": "812-782-1947",
  "custom_knock_propbro_number": "812-998-5886",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "812-624-6892",
  "custom_knock_maintenance_link": "http://www.ridgewoodsavannah.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191764/019e8492-e670-748a-b862-933928ae79f3.mp4",
  "custom_knock_maintenance_number": "812-641-7177",
  "custom_ppc_tracking_phone_number": "812-594-4450"
};

export const generatedAt = '2026-10-07T17:16:03.530Z';
